
import React, { useState } from 'react'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import Academicleft from '../Academic/Academicleft'

import { Container, Row } from "react-bootstrap";


function Main() {


    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };
    const faqData = [


        {
            id: 'heading1',
            question: 'Engineering Science / Arts',
            answer: `<table className="table table-bordered mb-40">            
            <tbody style="line-height: 2.5;">
            <tr classname='text-center'>
            <th>Course Code <br>(Since July, 2022)</th>
            <th>Course Title</th>
            <th>Approved In <br>Senate</th>
            <th>Course Code<br> (Prior to July, 2022)</th>
            </tr>
            <tr>
            <td>EA101M</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/EA101M.pdf' target='_blank;'>Engineering Drawing</a></td>
            <td>4</td>
            <td>EA1101</td>
            </tr>
            <tr>
            <td>EA102P</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/EA102P.pdf' target='_blank;'>Workshop I</a></td>
            <td>4</td>
            <td>EA1103</td>
            </tr>
            <tr>
            <td>EA103P</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/EA103P.pdf' target='_blank;'>Workshop II</a></td>
            <td>4</td>
            <td>EA1202</td>
            </tr>
            <tr>
            <td>EA104P</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/EA104P.pdf' target='_blank;'>Makers Laboratory</a></td>
            <td>26</td>
            <td> - </td>
            </tr>
            <tr>
            <td>EA105M</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/EA105M.pdf' target='_blank;'>Engineering Drawing</a></td>
            <td>26</td>
            <td> - </td>
            </tr>
            <tr>
            <td>ES101M</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES101M.pdf' target='_blank;'>Concepts in Engineering &amp; Design</a></td>
            <td>4</td>
            <td>ID1101</td>
            </tr>
            <tr>
            <td>ES102L</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES102L.pdf' target='_blank;'>Basic Electrical Engineering</a></td>
            <td>8</td>
            <td>ES1201</td>
            </tr>
            <tr>
            <td>ES103M</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES103M.pdf' target='_blank;'>Introduction to Programming</a></td>
            <td>14</td>
            <td>ES1101</td>
            </tr>
            <tr>
            <td>ES104M</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES104M.pdf' target='_blank;'>Computer Programming</a></td>
            <td>26</td>
            <td> - </td>
            </tr>
            <tr>
            <td>ES105L</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES105L.pdf' target='_blank;'>Foundations of Engineering Mechanics</a></td>
            <td>26</td>
            <td> - </td>
            </tr>
            <tr>
            <td>ES106L</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES106L.pdf' target='_blank;'>Introduction to Electrical Systems</a></td>
            <td>26</td>
            <td> - </td>
            </tr>
            <tr>
            <td>ES107L</td>
            <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES107L.pdf' target='_blank;'>Engineering Dynamics</a></td>
            <td>26</td>
            <td> - </td>
            </tr>

            <tr>
            <td>ES108L</td>
            <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES108L.pdf' target='_blank;'>Introduction to Electronic Systems</a></td>
            <td>27</td>
            <td> - </td>
            </tr>

            <tr>
            <td>ES109L</td>
            <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES109L.pdf' target='_blank;'>Introduction to Data Science and Machine Learning</a></td>
            <td>27</td>
            <td> - </td>
            </tr>
  
            <tr>
            <td>ES201L</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES201L.pdf' target='_blank;'>Engineering Mechanics</a></td>
            <td>4</td>
            <td>ES2101</td>
            </tr>
            <tr>

            <td>ES202L</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES202L.pdf' target='_blank;'>Ecology and Environment</a></td>
            <td>8</td>
            <td>ES2103</td>
            </tr>
            <tr>
            <td>ES203L</td>
            <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES203L.pdf' target='_blank;'>Life Sciences</a></td>
            <td>9</td>
            <td>BS2101</td>
            </tr>
            <tr>
            <td>ES204L</td>
            <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ES204L.pdf' target='_blank;'>Ecology, Environment and Sustainability</a></td>
            <td>27</td>
            <td> - </td>
            </tr>
            </tbody>
            </table>`,
        },
        {
            id: 'headingThree',
            question: 'Interdisciplinary',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                    <tr>
                    <th>Course Code <br>(Since July, 2022)</th>
                    <th>Course Title</th>
                    <th>Approved In <br>Senate</th>
                    <th>Course Code<br> (Prior to July, 2022)</th>
                    </tr>
                    <tr>
                    <td>ID301L</td>
                    <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ID301L.pdf' target='_blank;'>Product Innovation and Development</a></td>
                    <td>7</td>
                    <td>ID3022</td>
                    </tr>
                    <tr>
                    <td>ID501L</td>
                    <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ID501L.pdf' target='_blank;'>Mathematical Methods for Basic Sciences I</a></td>
                    <td>2</td>
                    <td>ID5101</td>
                    </tr>
                    <tr>
                    <td>ID502L</td>
                    <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ID502L.pdf' target='_blank;'>Innovation and Entrepreneurship</a></td>
                    <td>4</td>
                    <td>ID5022</td>
                    </tr>
                    <tr>
                    <td>ID503L</td>
                    <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ID503L.pdf' target='_blank;'>Physical Techniques for Material and Life Sciences</a></td>
                    <td>4</td>
                    <td>ID5021</td>
                    </tr>
                    <tr>
                    <td>ID504L</td>
                    <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ID504L.pdf' target='_blank;'>Design Thinking</a></td>
                    <td>22</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>ID601L</td>
                    <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ID601L.pdf' target='_blank;'>Mathematical Methods for Basic Sciences II</a></td>
                    <td>2</td>
                    <td>ID6101</td>
                    </tr>
                    <tr>
                    <td>ID602N</td>
                    <td><a className='c-link'  href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/ID602N.pdf' target='_blank;'>Introduction to Research</a></td>
                    <td>20</td>
                    <td>ID6020/20</td>
                    </tr>
                    <tr>
                    <td>IDXXXX</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ID/IDXXXX.pdf' target='_blank;'>Lifestyle Management</a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    </tbody>
                    </table>`,
        },
        {
            id: 'headingFour',
            question: 'Chemical Engineering',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                    <tr>
                    <th>Course Code <br>(Since July, 2022)</th>
                    <th>Course Title</th>
                    <th>Approved In <br>Senate</th>
                    <th>Course Code<br> (Prior to July, 2022)</th>
                    </tr>
                    <tr>
                    <td>CH101L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH101L.pdf' target='_blank;'>Chemical Process Calculations</a></td>
                    <td>26</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CH201L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH201L.pdf' target='_blank;'>Material and Energy Balances</a></td>
                    <td>12</td>
                    <td>CH2101</td>
                    </tr>
                    <tr>
                    <td>CH202L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH202L.pdf' target='_blank;'>Fluid and Particle Mechanics</a></td>
                    <td>12</td>
                    <td>CH2103</td>
                    </tr>
                    <tr>
                    <td>CH202P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH202P.pdf' target='_blank;'>Fluid and Particle Mechanics Laboratory</a></td>
                    <td>12</td>
                    <td>CH2191</td>
                    </tr>
                    <tr>
                    <td>CH203G</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH203G.pdf' target='_blank;'>Applied Process Engineering-I</a></td>
                    <td>12</td>
                    <td>CH2150</td>
                    </tr>
                    <tr>
                    <td>CH204L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH204L.pdf' target='_blank;'>Chemical Engineering Thermodynamics</a></td>
                    <td>12</td>
                    <td>CH2202</td>
                    </tr>
                    <tr>
                    <td>CH205L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH205L.pdf' target='_blank;'>Process Heat Transfer</a></td>
                    <td>12</td>
                    <td>CH2204</td>
                    </tr>
                    <tr>
                    <td>CH205P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH205P.pdf' target='_blank;'>Heat Transfer Laboratory</a></td>
                    <td>12</td>
                    <td>CH2292</td>
                    </tr>
                    <tr>
                    <td>CH206L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH206L.pdf' target='_blank;'>Fundamentals of Mass Transfer</a></td>
                    <td>12</td>
                    <td>CH2206</td>
                    </tr>
                    <tr>
                    <td>CH207G</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH207G.pdf' target='_blank;'>Applied Process Engineering-II</a></td>
                    <td>12</td>
                    <td>CH2250</td>
                    </tr>
                    <tr>
                    <tr>
                    <td>CH208L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH208L.pdf' target='_blank;'>Chemical Engineering Thermodynamics I </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>CH209G</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH209G.pdf' target='_blank;'>Applied Process Engineering -1 </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>CH210L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH210L.pdf' target='_blank;'>Fluid and Particle Mechanics </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>CH211P</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH211P.pdf' target='_blank;'>Fluid Mechanics and Heat Transfer Laboratory </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>CH212L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH212L.pdf' target='_blank;'>Chemical Reaction Engineering </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>CH213L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH213L.pdf' target='_blank;'>Process Heat Transfer </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>

                    <tr>
                    <td>CH214L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH214L.pdf' target='_blank;'>Chemical Engineering Thermodynamics II</a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>

                    <tr>
                    <td>CH215M</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH215M.pdf' target='_blank;'>Computational Techniques for Chemical Engineers </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>

                    <tr>
                    <td>CH216L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH216L.pdf' target='_blank;'>Fundamentals of Mass Transfer </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>

                    <tr>
                    <td>CH217G</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH217G.pdf' target='_blank;'>Applied Process Engineering -II </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>

                    <tr>
                    <td>CH218L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH218L.pdf' target='_blank;'>Process Dynamics and Control </a></td>
                    <td>28</td>
                    <td> </td>
                    </tr>


                    <td>CH301L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH301L.pdf' target='_blank;'>Homogeneous Reaction Engineering</a></td>
                    <td>12</td>
                    <td>CH3101</td>
                    </tr>
                    <tr>
                    <td>CH302L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH302L.pdf' target='_blank;'>Separation and Purification Processes</a></td>
                    <td>12</td>
                    <td>CH3103</td>
                    </tr>
                    <tr>
                    <td>CH302P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH302P.pdf' target='_blank;'>Mass Transfer Laboratory</a></td>
                    <td>12</td>
                    <td>CH3191</td>
                    </tr>
                    <tr>
                    <td>CH303L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH303L.pdf' target='_blank;'>Transport Phenomena</a></td>
                    <td>12</td>
                    <td>CH3105</td>
                    </tr>
                    <tr>
                    <td>CH304M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH304M.pdf' target='_blank;'>Computational Techniques for Chemical Engineers</a></td>
                    <td>12</td>
                    <td>CH3107</td>
                    </tr>
                    <tr>
                    <td>CH305G</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH305G.pdf' target='_blank;'>Applied Process Engineering-III</a></td>
                    <td>12</td>
                    <td>CH3150</td>
                    </tr>
                    <tr>
                    <td>CH306L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH306L.pdf' target='_blank;'>Heterogeneous Reaction Engineering</a></td>
                    <td>12</td>
                    <td>CH3202</td>
                    </tr>
                    <tr>
                    <td>CH306P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH306P.pdf' target='_blank;'>Reaction Engineering Laboratory</a></td>
                    <td>12</td>
                    <td>CH3292</td>
                    </tr>
                    <tr>
                    <td>CH307L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH307L.pdf' target='_blank;'>Process Control and Instrumentation</a></td>
                    <td>12</td>
                    <td>CH3204</td>
                    </tr>
                    <tr>
                    <td>CH307P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH307P.pdf' target='_blank;'>Process Control Laboratory</a></td>
                    <td>12</td>
                    <td>CH3294</td>
                    </tr>
                    <tr>
                    <td>CH308M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH308M.pdf' target='_blank;'>Process Equipment Design</a></td>
                    <td>12</td>
                    <td>CH3206</td>
                    </tr>
                    <tr>
                    <td>CH309G</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH309G.pdf' target='_blank;'>Applied Process Engineering-IV</a></td>
                    <td>12</td>
                    <td>CH3250</td>
                    </tr>


                    <tr>
                    <td>CH310L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH310L.pdf' target='_blank;'>Separation Processes</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH312L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH312L.pdf' target='_blank;'>Transport Phenomena</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH313P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH313P.pdf' target='_blank;'>Chemical Reaction Engineering Laboratory</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH314P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH314P.pdf' target='_blank;'>Process Control Laboratory</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH315G</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH315G.pdf' target='_blank;'>Applied Process Engineering-III</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH316L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH316L.pdf' target='_blank;'>Process Synthesis and Economics</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH317M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH317M.pdf' target='_blank;'>Chemical Technology</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH318L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH318L.pdf' target='_blank;'>Bioprocess Engineering</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH319P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH319P.pdf' target='_blank;'>Separations Laboratory</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CH320P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH320P.pdf' target='_blank;'>Process Design and Simulation Laboratory
                    </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>

                    <tr>
                    <td>CH401L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH401L.pdf' target='_blank;'>Process Synthesis and Economics</a></td>
                    <td>12</td>
                    <td>CH4101</td>
                    </tr>
                    <tr>
                    <td>CH402L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH402L.pdf' target='_blank;'>Process Safety and Industrial Pollution</a></td>
                    <td>12</td>
                    <td>CH4103</td>
                    </tr>
                    <tr>
                    <td>CH404L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH404L.pdf' target='_blank;'>Bioprocess Engineering</a></td>
                    <td>12</td>
                    <td>CH4202</td>
                    </tr>
                    <tr>
                    <td>CH407L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH407L.pdf' target='_blank;'>Corrosion Engineering</a></td>
                    <td>12</td>
                    <td>CH4021</td>
                    </tr>
                    <tr>
                    <td>CH408L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH408L.pdf' target='_blank;'>Oil and Gas Engineering</a></td>
                    <td>12</td>
                    <td>CH4023</td>
                    </tr>
                    <tr>
                    <td>CH501L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH501L.pdf' target='_blank;'>Microscale Unit Operations</a></td>
                    <td>14</td>
                    <td>CH5021</td>
                    </tr>
                    <tr>
                    <td>CH502L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH502L.pdf' target='_blank;'>Optimization Techniques</a></td>
                    <td>14</td>
                    <td>CH5022</td>
                    </tr>
                    <tr>
                    <td>CH503L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH503L.pdf' target='_blank;'>Adsorption Science and Technology</a></td>
                    <td>16</td>
                    <td>CH5023</td>
                    </tr>
                    <tr>
                    <td>CH504L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH504L.pdf' target='_blank;'>Introduction to Colloids and Interfaces</a></td>
                    <td>16</td>
                    <td>CH5024</td>
                    </tr>
                    <tr>
                    <td>CH505L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH505L.pdf' target='_blank;'>Modern Process Control</a></td>
                    <td>16</td>
                    <td>CH5025</td>
                    </tr>
                    <tr>
                    <td>CH506M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH506M.pdf' target='_blank;'>Analytical Techniques and Instrumentation</a></td>
                    <td>17</td>
                    <td>CH5026</td>
                    </tr>
                    <tr>
                    <td>CH507L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH507L.pdf' target='_blank;'>Bioprocess Intensification and Integration</a></td>
                    <td>17</td>
                    <td>CH5028</td>
                    </tr>
                    <tr>
                    <td>CH508L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH508L.pdf' target='_blank;'>Food Processing Technology</a></td>
                    <td>17</td>
                    <td>CH5029</td>
                    </tr>
                    <tr>
                    <td>CH509L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH509L.pdf' target='_blank;'>Introduction to Nanoscience and Technology</a></td>
                    <td>17</td>
                    <td>CH5027</td>
                    </tr>
                    <tr>
                    <td>CH510L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH510L.pdf' target='_blank;'>Machine Learning in Process Engineering</a></td>
                    <td>17</td>
                    <td>CH5030</td>
                    </tr>
                    <tr>
                    <td>CH511L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH511L.pdf' target='_blank;'>Biological Fluid Mechanics</a></td>
                    <td>20</td>
                    <td>CH5031</td>
                    </tr>
                    <tr>
                    <td>CH512L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH512L.pdf' target='_blank;'>Introduction to Molecular Dynamics Simulations</a></td>
                    <td>21</td>
                    <td>CH5032</td>
                    </tr>
                    <tr>
                    <td>CH513L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH513L.pdf' target='_blank;'>Chemical Reactor Analysis and Design</a></td>
                    <td>23</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CH514L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH514L.pdf' target='_blank;'>Mathematical Methods for Chemical Engineers</a></td>
                    <td>23</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CH515L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH515L.pdf' target='_blank;'>Molecular Thermodynamics</a></td>
                    <td>23</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CH516M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH516M.pdf' target='_blank;'>Process Simulations Laboratory</a></td>
                    <td>23</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CH517L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH517L.pdf' target='_blank;'>Transport Processes</a></td>
                    <td>23</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CH518L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH518L.pdf' target='_blank;'>Electrochemical Energy Storage </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CH519L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH519L.pdf' target='_blank;'>Physics of Softmatter </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>

                    <tr>
                    <td>CH520L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH520L.pdf' target='_blank;'>Engineering Economics and Sustainability </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>

                    <tr>
                    <td>CH521L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH521L.pdf' target='_blank;'>Introduction to Microfluidics </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>

                    <tr>
                    <td>CH522L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH522L.pdf' target='_blank;'>Corrosion Engineering  </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>

                    <tr>
                    <td>CH523L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CH/CH523L.pdf' target='_blank;'>Chemical Production Scheduling </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>

                    </tbody>
                    </table>`,
        },
        {
            id: 'headingFive',
            question: 'Chemistry',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                    <tr>
                    <th>Course Code <br>(Since July, 2022)</th>
                    <th>Course Title</th>
                    <th>Approved In <br>Senate</th>
                    <th>Course Code<br> (Prior to July, 2022)</th>
                    </tr>
                    <tr>
                    <td>CY101L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY101L.pdf' target='_blank;'>Physical and Theoretical Chemistry</a></td>
                    <td>4</td>
                    <td>CY1101</td>
                    </tr>
                    <tr>
                    <td>CY102L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY102L.pdf' target='_blank;'>Organic and Inorganic Chemistry</a></td>
                    <td>4</td>
                    <td>CY1202</td>
                    </tr>
                    <tr>
                    <td>CY103P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY103P.pdf' target='_blank;'>Chemistry Laboratory</a></td>
                    <td>4</td>
                    <td>CY1204</td>
                    </tr>
                    <tr>
                    <td>CY104L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY104L.pdf' target='_blank;'>Chemistry for Engineers</a></td>
                    <td>26</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CY501L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY501L.pdf' target='_blank;'>Quantum Chemistry and Chemical Bonding</a></td>
                    <td>10</td>
                    <td>CY5101</td>
                    </tr>
                    <tr>
                    <td>CY502L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY502L.pdf' target='_blank;'>Transition Metals and Coordination Chemistry</a></td>
                    <td>10</td>
                    <td>CY5103</td>
                    </tr>
                    <tr>
                    <td>CY503L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY503L.pdf' target='_blank;'>Reactions and Reagents in Organic Chemistry</a></td>
                    <td>10</td>
                    <td>CY5105</td>
                    </tr>
                    <tr>
                    <td>CY504L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY504L.pdf' target='_blank;'>Thermodynamics and Chemical Kinetics</a></td>
                    <td>10</td>
                    <td>CY5107</td>
                    </tr>
                    <tr>
                    <td>CY505L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY505L.pdf' target='_blank;'>Main Group and Organometallic Chemistry</a></td>
                    <td>10</td>
                    <td>CY5109</td>
                    </tr>
                    <tr>
                    <td>CY506P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY506P.pdf' target='_blank;'>Organic Chemistry Laboratory</a></td>
                    <td>19</td>
                    <td>CY5191</td>
                    </tr>
                    <tr>
                    <td>CY507L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY507L.pdf' target='_blank;'>Principles of Spectroscopy</a></td>
                    <td>10</td>
                    <td>CY5202</td>
                    </tr>
                    <tr>
                    <td>CY508L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY508L.pdf' target='_blank;'>Stereochemistry and Organic Synthesis</a></td>
                    <td>10</td>
                    <td>CY5204</td>
                    </tr>
                    <tr>
                    <td>CY509L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY509L.pdf' target='_blank;'>Symmetry and Group Theory</a></td>
                    <td>11</td>
                    <td>CY5206</td>
                    </tr>
                    <tr>
                    <td>CY510L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY510L.pdf' target='_blank;'>Bioinorganic and Environmental Chemistry</a></td>
                    <td>10</td>
                    <td>CY5208</td>
                    </tr>
                    <tr>
                    <td>CY511M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY511M.pdf' target='_blank;'>Computer Programming and Numerical Methods in Chemistry</a></td>
                    <td>10</td>
                    <td>CY5210</td>
                    </tr>
                    <tr>
                    <td>CY512P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY512P.pdf' target='_blank;'>Inorganic Chemistry Laboratory</a></td>
                    <td>10</td>
                    <td>CY5292</td>
                    </tr>
                    <tr>
                    <td>CY513L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY513L.pdf' target='_blank;'>Statistical Mechanics</a></td>
                    <td>6</td>
                    <td>CY5022</td>
                    </tr>
                    <tr>
                    <td>CY514L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY514L.pdf' target='_blank;'>Supramolecular Architectures and Molecular Machines: Fundamentals and Applications</a></td>
                    <td>18</td>
                    <td>CY5027</td>
                    </tr>
                    <tr>
                    <td>CY515L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY515L.pdf' target='_blank;'>Introduction to Polymer Science</a></td>
                    <td>6</td>
                    <td>CY5021</td>
                    </tr>
                    <tr>
                    <td>CY516L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY516L.pdf' target='_blank;'>Computational Methods in Materials Science</a></td>
                    <td>6</td>
                    <td>CY5023</td>
                    </tr>
                    <tr>
                    <td>CY601L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY601L.pdf' target='_blank;'>Electrochemistry and Chemistry of Solids</a></td>
                    <td>10</td>
                    <td>CY6101</td>
                    </tr>
                    <tr>
                    <td>CY602L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY602L.pdf' target='_blank;'>Applications of Spectroscopy in Inorganic and Organic Chemistry</a></td>
                    <td>10</td>
                    <td>CY6103</td>
                    </tr>
                    <tr>
                    <td>CY603P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY603P.pdf' target='_blank;'>Physical Chemistry Laboratory</a></td>
                    <td>10</td>
                    <td>CY6191</td>
                    </tr>
                    <tr>
                    <td>CY604L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY604L.pdf' target='_blank;'>Biomolecules and Chemical Biology</a></td>
                    <td>10</td>
                    <td>CY6202</td>
                    </tr>
                    <tr>
                    <td>CY605L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY605L.pdf' target='_blank;'>Pericyclic Reactions and Photochemistry</a></td>
                    <td>10</td>
                    <td>CY6024</td>
                    </tr>
                    <tr>
                    <td>CY606L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY606L.pdf' target='_blank;'>Chemistry of Heterocyclics and Natural Products</a></td>
                    <td>18</td>
                    <td>CY6025</td>
                    </tr>
                    <tr>
                    <td>CY607L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY607L.pdf' target='_blank;'>Nanochemistry Principles and Applications</a></td>
                    <td>22</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CY608L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY608L.pdf' target='_blank;'>Chemistry of p and f Block Elements </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CY609L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY609L.pdf' target='_blank;'>Biophysical Chemistry </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CY610L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY610L.pdf' target='_blank;'>Modern Methods for Asymmetric Synthesis </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CY611L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY611L.pdf' target='_blank;'>Classical Molecular Simulation Methods and Applications </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CY612L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY612L.pdf' target='_blank;'>Modern Electronic Structure Methods and Applications </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CY613L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CY/CY613L.pdf' target='_blank;'>Chemistry of Inorganic Clusters </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>

                    </tbody>
                    </table>`,
        },

        {
            id: 'headingSix',
            question: 'Civil and Environmental Engineering',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                    <tr>
                    <th>Course Code <br>(Since July, 2022)</th>
                    <th>Course Title</th>
                    <th>Approved In <br>Senate</th>
                    <th>Course Code<br> (Prior to July, 2022)</th>
                    </tr>
                    <tr>
                    <td>CE101L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE101L.pdf' target='_blank;'>Strength of Materials</a></td>
                    <td>27</td>
                    <td>CE2101</td>
                    </tr>
                    <tr>
                    <td>CE202L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE202L.pdf' target='_blank;'>Civil Engineering Materials and Construction</a></td>
                    <td>8</td>
                    <td>CE2105</td>
                    </tr>
                    <tr>
                    <td>CE203L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE203L.pdf' target='_blank;'>Surveying</a></td>
                    <td>8</td>
                    <td>CE2103</td>
                    </tr>
                    <tr>
                    <td>CE203P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE203P.pdf' target='_blank;'>Surveying Practical</a></td>
                    <td>8</td>
                    <td>CE2191</td>
                    </tr>
                    <tr>
                    <td>CE204L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE204L.pdf' target='_blank;'>Geology and Soil Mechanics</a></td>
                    <td>8</td>
                    <td>CE2204</td>
                    </tr>
                    <tr>
                    <td>CE205P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE205P.pdf' target='_blank;'>Building Drawing</a></td>
                    <td>8</td>
                    <td>CE2294</td>
                    </tr>
                    <tr>
                    <td>CE206L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE206L.pdf' target='_blank;'>Structural Analysis</a></td>
                    <td>8</td>
                    <td>CE2202</td>
                    </tr>
                    <tr>
                    <td>CE206P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE206P.pdf' target='_blank;'>Structural Engineering Laboratory</a></td>
                    <td>8</td>
                    <td>CE2292</td>
                    </tr>
                    <tr>
                    <td>CE207L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE207L.pdf' target='_blank;'>Fluid Mechanics and Hydraulics</a></td>
                    <td>8</td>
                    <td>CE2206</td>
                    </tr>

                    <tr>
                    <td>CE208L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE208L.pdf' target='_blank;'>Structural Analysis </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>

                    <tr>
                    <td>CE209M</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE209M.pdf' target='_blank;'>Surveying </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CE210M</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE210M.pdf' target='_blank;'>Civil Engineering Materials </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CE211L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE211L.pdf' target='_blank;'>Fluid Mechanics </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CE212L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE212L.pdf' target='_blank;'>Engineering Geology </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CE213P</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE213P.pdf' target='_blank;'>Mechanics Laboratory </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CE214M</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE214M.pdf' target='_blank;'>Soil Mechanics </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>
                    <tr>
                    <td>CE215L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE215L.pdf' target='_blank;'>Structural Steel Design </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>

                    <tr>
                    <td>CE216L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE216L.pdf' target='_blank;'>Water and Wastewater Engineering </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>

                    <tr>
                    <td>CE217L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE217L.pdf' target='_blank;'>Hydraulics </a></td>
                    <td>28</td>
                    <td></td>
                    </tr>

                    <tr>
                    <td>CE218M</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE218M.pdf' target='_blank;'>Transportation Engineering</a></td>
                    <td>28</td>
                    <td></td>
                    </tr>

                    <tr>
                    <td>CE301L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE301L.pdf' target='_blank;'>Basic Structural Steel Design</a></td>
                    <td>8</td>
                    <td>CE3101</td>
                    </tr>
                    <tr>
                    <td>CE302L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE302L.pdf' target='_blank;'>Water Resources Engineering</a></td>
                    <td>8</td>
                    <td>CE3103</td>
                    </tr>
                    <tr>
                    <td>CE303L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE303L.pdf' target='_blank;'>Environmental Engineering</a></td>
                    <td>8</td>
                    <td>CE3105</td>
                    </tr>
                    <tr>
                    <td>CE304P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE304P.pdf' target='_blank;'>Building Materials Laboratory</a></td>
                    <td>8</td>
                    <td>CE3193</td>
                    </tr>
                    <tr>
                    <td>CE305P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE305P.pdf' target='_blank;'>Hydraulics and Environmental Engineering Laboratory</a></td>
                    <td>8</td>
                    <td>CE3191</td>
                    </tr>
                    <tr>
                    <td>CE306L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE306L.pdf' target='_blank;'>Basic Reinforced Concrete Design</a></td>
                    <td>8</td>
                    <td>CE3202</td>
                    </tr>
                    <tr>
                    <td>CE307L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE307L.pdf' target='_blank;'>Geotechnical Engineering</a></td>
                    <td>8</td>
                    <td>CE3204</td>
                    </tr>
                    <tr>
                    <td>CE308L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE308L.pdf' target='_blank;'>Transportation Engineering</a></td>
                    <td>8</td>
                    <td>CE3206</td>
                    </tr>
                    <tr>
                    <td>CE308P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE308P.pdf' target='_blank;'>Transportation Engineering Laboratory</a></td>
                    <td>8</td>
                    <td>CE3292</td>
                    </tr>
                    <tr>
                    <td>CE309L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE309L.pdf' target='_blank;'>Concrete Technology</a></td>
                    <td>8</td>
                    <td>CE3107</td>
                    </tr>
                    <tr>
                    <td>CE310L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE310L.pdf' target='_blank;'>Advanced Structural Analysis</a></td>
                    <td>8</td>
                    <td>CE3021</td>
                    </tr>
                    <tr>
                    <td>CE401L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE401L.pdf' target='_blank;'>Estimation and Construction Management</a></td>
                    <td>8</td>
                    <td>CE4101</td>
                    </tr>
                    <tr>
                    <td>CE402L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE402L.pdf' target='_blank;'>Functional Design of Buildings</a></td>
                    <td>8</td>
                    <td>CE4103</td>
                    </tr>
                    <tr>
                    <td>CE501L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE501L.pdf' target='_blank;'>Prestressed Concrete Design</a></td>
                    <td>14</td>
                    <td>CE5121</td>
                    </tr>
                    <tr>
                    <td>CE502L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE502L.pdf' target='_blank;'>Pavement Materials and Construction</a></td>
                    <td>2</td>
                    <td>CE5101</td>
                    </tr>
                    <tr>
                    <td>CE503L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE503L.pdf' target='_blank;'>Structural Dynamics</a></td>
                    <td>2</td>
                    <td>CE5102</td>
                    </tr>
                    <tr>
                    <td>CE504L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE504L.pdf' target='_blank;'>Chemical Processes for Environmental Engineering</a></td>
                    <td>3</td>
                    <td style='font-weight: 400;'>CE5111</td>
                    </tr>
                    <tr>
                    <td>CE505L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE505L.pdf' target='_blank;'>Groundwater Hydrology</a></td>
                    <td>6</td>
                    <td>CE5021</td>
                    </tr>
                    <tr>
                    <td>CE506L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE506L.pdf' target='_blank;'>Pavement Analysis and Design</a></td>
                    <td>3</td>
                    <td>CE5117</td>
                    </tr>
                    <tr>
                    <td>CE507L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE507L.pdf' target='_blank;'>Soil Dynamics and Geotechnical Earthquake Engineering</a></td>
                    <td>3</td>
                    <td>CE5211</td>
                    </tr>
                    <tr>
                    <td>CE508L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE508L.pdf' target='_blank;'>Structural Stability and Design</a></td>
                    <td>3</td>
                    <td>CE5115</td>
                    </tr>
                    <tr>
                    <td>CE509L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE509L.pdf' target='_blank;'>Groundwater Modelling</a></td>
                    <td>3</td>
                    <td>CE5113</td>
                    </tr>
                    <tr>
                    <td>CE510L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE510L.pdf' target='_blank;'>Traffic Flow Modeling and Simulation</a></td>
                    <td>6</td>
                    <td>CE5022</td>
                    </tr>
                    <tr>
                    <td>CE511L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE511L.pdf' target='_blank;'>Integrated Impact Assessment</a></td>
                    <td>7</td>
                    <td>CE5023</td>
                    </tr>
                    <tr>
                    <td>CE512L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE512L.pdf' target='_blank;'>Solid and Hazardous Waste Management</a></td>
                    <td>7</td>
                    <td>CE5024</td>
                    </tr>
                    <tr>
                    <td>CE513L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE513L.pdf' target='_blank;'>Water Resources Planning and Management</a></td>
                    <td>7</td>
                    <td>CE5025</td>
                    </tr>
                    <tr>
                    <td>CE514L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE514L.pdf' target='_blank;'>Advanced Design of Concrete Structures</a></td>
                    <td>8</td>
                    <td>CE5108</td>
                    </tr>
                    <tr>
                    <td>CE515L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE515L.pdf' target='_blank;'>Advanced Design of Metal Structures</a></td>
                    <td>8</td>
                    <td>CE5204</td>
                    </tr>
                    <tr>
                    <td>CE516P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE516P.pdf' target='_blank;'>Advanced Structural Engineering Laboratory</a></td>
                    <td>8</td>
                    <td>CE5193</td>
                    </tr>
                    <tr>
                    <td>CE517L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE517L.pdf' target='_blank;'>Air Pollution Control Engineering</a></td>
                    <td>8</td>
                    <td>CE5105</td>
                    </tr>
                    <tr>
                    <td>CE518L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE518L.pdf' target='_blank;'>Applied Hydraulic Engineering</a></td>
                    <td>8</td>
                    <td>CE5106</td>
                    </tr>
                    <tr>
                    <td>CE519L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE519L.pdf' target='_blank;'>Biological Processes in Wastewater Engineering</a></td>
                    <td>8</td>
                    <td>CE5202</td>
                    </tr>
                    <tr>
                    <td>CE520L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE520L.pdf' target='_blank;'>Earthquake and Wind Engineering</a></td>
                    <td>8</td>
                    <td>CE5028</td>
                    </tr>
                    <tr>
                    <td>CE521L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE521L.pdf' target='_blank;'>Environmental Chemistry</a></td>
                    <td>8</td>
                    <td style='font-weight: 400;' width='145'>CE5111</td>
                    </tr>
                    <tr>
                    <td>CE522P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE522P.pdf' target='_blank;'>Environmental Monitoring Laboratory</a></td>
                    <td>8</td>
                    <td>CE5291</td>
                    </tr>
                    <tr>
                    <td>CE523M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE523M.pdf' target='_blank;'>Environmental Risk Assessment</a></td>
                    <td>8</td>
                    <td style='font-weight: 400;' width='145'>CE5026</td>
                    </tr>
                    <tr>
                    <td>CE524L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE524L.pdf' target='_blank;'>Geotechnical Investigations and Foundation Design</a></td>
                    <td>8</td>
                    <td>CE5027</td>
                    </tr>
                    <tr>
                    <td>CE525M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE525M.pdf' target='_blank;'>GIS and Remote Sensing</a></td>
                    <td>8</td>
                    <td style='font-weight: 400;' width='145'>CE5026</td>
                    </tr>
                    <tr>
                    <td>CE526L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE526L.pdf' target='_blank;'>Ground Improvement and Geosynthetics</a></td>
                    <td>8</td>
                    <td>CE5206</td>
                    </tr>
                    <tr>
                    <td>CE526P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE526P.pdf' target='_blank;'>Ground Improvement and Geosynthetics Laboratory</a></td>
                    <td>11</td>
                    <td>CE5294</td>
                    </tr>
                    <tr>
                    <td>CE527P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE527P.pdf' target='_blank;'>Hydroinformatics Laboratory</a></td>
                    <td>8</td>
                    <td>CE5191</td>
                    </tr>
                    <tr>
                    <td>CE528L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE528L.pdf' target='_blank;'>Health Monitoring of Civil Engineering Structures</a></td>
                    <td>22</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CE529P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE529P.pdf' target='_blank;'>Pavement Engineering Laboratory</a></td>
                    <td>8</td>
                    <td>CE5195</td>
                    </tr>
                    <tr>
                    <td>CE530L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE530L.pdf' target='_blank;'>Physicochemical Processes in Water and Wastewater Engineering</a></td>
                    <td>8</td>
                    <td>CE5104</td>
                    </tr>
                    <tr>
                    <td>CE531L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE531L.pdf' target='_blank;'>Random Vibrations and Structural Reliability</a></td>
                    <td>8</td>
                    <td>CE5030</td>
                    </tr>
                    <tr>
                    <td>CE532L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE532L.pdf' target='_blank;'>Surface Water Hydrology</a></td>
                    <td>8</td>
                    <td>CE5107</td>
                    </tr>
                    <tr>
                    <td>CE533L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE533L.pdf' target='_blank;'>Traffic Engineering and Road Safety</a></td>
                    <td>8</td>
                    <td>CE5109</td>
                    </tr>
                    <tr>
                    <td>CE533P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE533P.pdf' target='_blank;'>Traffic Engineering Laboratory</a></td>
                    <td>8</td>
                    <td>CE5197</td>
                    </tr>
                    <tr>
                    <td>CE534L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE534L.pdf' target='_blank;'>Advanced Soil Mechanics</a></td>
                    <td>11</td>
                    <td>CE5112</td>
                    </tr>
                    <tr>
                    <td>CE534P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE534P.pdf' target='_blank;'>Advanced Soil Mechanics Laboratory</a></td>
                    <td>11</td>
                    <td>CE5199</td>
                    </tr>
                    <tr>
                    <td>CE535L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE535L.pdf' target='_blank;'>Geoenvironmental Engineering</a></td>
                    <td>11</td>
                    <td>CE5033</td>
                    </tr>
                    <tr>
                    <td>CE536L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE536L.pdf' target='_blank;'>Rock Mechanics</a></td>
                    <td>11</td>
                    <td>CE5031</td>
                    </tr>
                    <tr>
                    <td>CE537L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE537L.pdf' target='_blank;'>Unsaturated Soil Mechanics and Applications</a></td>
                    <td>11</td>
                    <td>CE5032</td>
                    </tr>
                    <tr>
                    <td>CE538L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE538L.pdf' target='_blank;'>Advanced Concrete Technology</a></td>
                    <td>12</td>
                    <td>CE5034</td>
                    </tr>
                    <tr>
                    <td>CE539L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE539L.pdf' target='_blank;'>Advanced Mechanics of Solids</a></td>
                    <td>2</td>
                    <td>CE5103</td>
                    </tr>
                    <tr>
                    <td>CE540L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE540L.pdf' target='_blank;'>Introduction to Geodesy</a></td>
                    <td>22</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>CE541M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CEE/CE541M.pdf' target='_blank;'>Synthetic Aperture Radar and Applications</a></td>
                    <td>23</td>
                    <td> - </td>
                    </tr>

                    </tbody>
                    </table>`
        },

        {
            id: 'headingSeven',
            question: 'Computer Science and Engineering',
            answer: `<table className='table table-bordered mb-40'>   
                    <tbody style="line-height: 2.5;">
                        <tr>
                        <th>Course Code <br>(Since July, 2022)</th>
                        <th>Course Title</th>
                        <th>Approved In <br>Senate</th>
                        <th>Course Code<br> (Prior to July, 2022)</th>
                        </tr>
                        <tr>
                        <td>CS201L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS201L.pdf' target='_blank;'>Discrete Mathematics for Computer Science</a></td>
                        <td>8</td>
                        <td>CS2103</td>
                        </tr>
                        <tr>
                        <td>CS202M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS202M.pdf' target='_blank;'>Programming Methodology</a></td>
                        <td>8</td>
                        <td>CS2105</td>
                        </tr>
                        <tr>
                        <td>CS203L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS203L.pdf' target='_blank;'>Computer Organization</a></td>
                        <td>8</td>
                        <td>CS2204</td>
                        </tr>
                        <tr>
                        <td>CS203P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS203P.pdf' target='_blank;'>Computer Organization Laboratory</a></td>
                        <td>8</td>
                        <td>CS2292</td>
                        </tr>
                        <tr>
                        <td>CS204L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS204L.pdf' target='_blank;'>Data Structures and Algorithms</a></td>
                        <td>8</td>
                        <td>CS2206</td>
                        </tr>
                        <tr>
                        <td>CS204P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS204P.pdf' target='_blank;'>Data Structures and Algorithms Laboratory</a></td>
                        <td>8</td>
                        <td>CS2294</td>
                        </tr>
                        <tr>
                        <td>CS205L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS205L.pdf' target='_blank;'>Theory of Computation</a></td>
                        <td>8</td>
                        <td>CS2202</td>
                        </tr>
                        <tr>
                        <td>CS206L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS206L.pdf' target='_blank;'>Digital Systems</a></td>
                        <td>8</td>
                        <td>CS2101</td>
                        </tr>
                        <tr>
                        <td>CS206P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS206P.pdf' target='_blank;'>Digital Systems Laboratory</a></td>
                        <td>8</td>
                        <td>CS2191</td>
                        </tr>
                        <tr>
                        <td>CS207L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS207L.pdf' target='_blank;'>Discrete Mathematics for Computer Science </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>CS210M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS210M.pdf' target='_blank;'>Digital Logic Design</a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>CS211L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS211L.pdf' target='_blank;'>Software Engineering </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>CS212P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS212P.pdf' target='_blank;'>Software Systems and Tools Laboratory </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>CS208M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS208M.pdf' target='_blank;'>Digital Logic Design </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>CS209L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS209L.pdf' target='_blank;'>Computer Organisation and Architecture </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>CS209M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS209M.pdf' target='_blank;'>Computer Organisation and Architecture Laboratory </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>CS301L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS301L.pdf' target='_blank;'>Compiler Design</a></td>
                        <td>8</td>
                        <td>CS3103</td>
                        </tr>
                        <tr>
                        <td>CS301P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS301P.pdf' target='_blank;'>Compiler Design Laboratory</a></td>
                        <td>8</td>
                        <td>CS3191</td>
                        </tr>
                        <tr>
                        <td>CS302L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS302L.pdf' target='_blank;'>Software Engineering</a></td>
                        <td>8</td>
                        <td>CS3105</td>
                        </tr>
                        <tr>
                        <td>CS302P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS302P.pdf' target='_blank;'>Software Engineering Laboratory</a></td>
                        <td>8</td>
                        <td>CS3294</td>
                        </tr>
                        <tr>
                        <td>CS303L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS303L.pdf' target='_blank;'>Machine Learning</a></td>
                        <td>12</td>
                        <td>CS3109</td>
                        </tr>
                        <tr>
                        <td>CS303P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS303P.pdf' target='_blank;'>Intelligent Systems Laboratory</a></td>
                        <td>12</td>
                        <td>CS3296</td>
                        </tr>
                        <tr>
                        <td>CS304L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS304L.pdf' target='_blank;'>Design and Analysis of Algorithms</a></td>
                        <td>8</td>
                        <td>CS3101</td>
                        </tr>
                        <tr>
                        <td>CS305L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS305L.pdf' target='_blank;'>Operating Systems</a></td>
                        <td>8</td>
                        <td>CS3107</td>
                        </tr>
                        <tr>
                        <td>CS305P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS305P.pdf' target='_blank;'>Operating Systems Laboratory</a></td>
                        <td>8</td>
                        <td>CS3193</td>
                        </tr>
                        <tr>
                        <td>CS306L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS306L.pdf' target='_blank;'>Computer Networks</a></td>
                        <td>8</td>
                        <td>CS3202</td>
                        </tr>
                        <tr>
                        <td>CS306P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS306P.pdf' target='_blank;'>Computer Networks Laboratory</a></td>
                        <td>8</td>
                        <td>CS3292</td>
                        </tr>
                        <tr>
                        <td>CS307L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS307L.pdf' target='_blank;'>Artificial Intelligence</a></td>
                        <td>12</td>
                        <td>CS3204</td>
                        </tr>
                        <tr>
                        <td>CS308M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS308M.pdf' target='_blank;'>Database Systems</a></td>
                        <td>8</td>
                        <td>CS3206</td>
                        </tr>
                        <tr>
                        <td>CS309L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS309L.pdf' target='_blank;'>Operating Systems </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>CS311M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS311M.pdf' target='_blank;'>Object Oriented Programming</a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>CS312P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS312P.pdf' target='_blank;'>Computer Networks Laboratory </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>CS313P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS313P.pdf' target='_blank;'>Compiler Design Laboratory </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>CS314P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS314P.pdf' target='_blank;'>Operating Systems Laboratory </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>

                        <tr>
                        <td>CS401L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS401L.pdf' target='_blank;'>Computer System Design</a></td>
                        <td>8</td>
                        <td>CS4101</td>
                        </tr>
                        <tr>
                        <td>CS401P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS401P.pdf' target='_blank;'>Computer System Design Laboratory</a></td>
                        <td>8</td>
                        <td>CS4191</td>
                        </tr>
                        <tr>
                        <td>CS402N</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS402N.pdf' target='_blank;'>Industrial Lecture</a></td>
                        <td>1</td>
                        <td>IL4101</td>
                        </tr>
                        <tr>
                        <td>CS402M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS402M.pdf' target='_blank;'>Computer Systems Security</a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>CS501L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS501L.pdf' target='_blank;'>Cryptography and Network Security</a></td>
                        <td>2</td>
                        <td>CS5101</td>
                        </tr>
                        <tr>
                        <td>CS502L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS502L.pdf' target='_blank;'>Advanced Computer Networks</a></td>
                        <td>4</td>
                        <td>CS5021</td>
                        </tr>
                        <tr>
                        <td>CS503L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS503L.pdf' target='_blank;'>Advanced Data Structures and Algorithms</a></td>
                        <td>4</td>
                        <td>CS5101</td>
                        </tr>
                        <tr>
                        <td>CS503P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS503P.pdf' target='_blank;'>Advanced Data Structures and Algorithms Laboratory</a></td>
                        <td>5</td>
                        <td>CS5191</td>
                        </tr>
                        <tr>
                        <td>CS504L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS504L.pdf' target='_blank;'>Algorithmic Engineering</a></td>
                        <td>6</td>
                        <td>CS5022</td>
                        </tr>
                        <tr>
                        <td>CS505L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS505L.pdf' target='_blank;'>Computational Complexity Theory</a></td>
                        <td>6</td>
                        <td>CS5023</td>
                        </tr>
                        <tr>
                        <td>CS506L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS506L.pdf' target='_blank;'>Computer System Architecture</a></td>
                        <td>6</td>
                        <td>CS5202</td>
                        </tr>
                        <tr>
                        <td>CS507L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS507L.pdf' target='_blank;'>Data Science for Software Engineering</a></td>
                        <td>6</td>
                        <td>CS5024</td>
                        </tr>
                        <tr>
                        <td>CS508L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS508L.pdf' target='_blank;'>Performance Evaluation of Computer Systems</a></td>
                        <td>6</td>
                        <td>CS5026</td>
                        </tr>
                        <tr>
                        <td>CS509L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS509L.pdf' target='_blank;'>Predictive Data Modelling</a></td>
                        <td>6</td>
                        <td>CS5025</td>
                        </tr>
                        <tr>
                        <td>CS510L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS510L.pdf' target='_blank;'>Computational Geometry</a></td>
                        <td>8</td>
                        <td>CS5027</td>
                        </tr>
                        <tr>
                        <td>CS511L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS511L.pdf' target='_blank;'>Artificial Neural Networks</a></td>
                        <td>20</td>
                        <td>CS5222</td>
                        </tr>
                        <tr>
                        <td>CS512L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS512L.pdf' target='_blank;'>GPU Computing</a></td>
                        <td>10</td>
                        <td>CS5221</td>
                        </tr>
                        <tr>
                        <td>CS513L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS513L.pdf' target='_blank;'>Industrial Data Science and Engineering</a></td>
                        <td>10</td>
                        <td>CS5223</td>
                        </tr>
                        <tr>
                        <td>CS514L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS514L.pdf' target='_blank;'>Artificial Intelligence</a></td>
                        <td>12</td>
                        <td>CS5204</td>
                        </tr>
                        <tr>
                        <td>CS515L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS515L.pdf' target='_blank;'>Computational Methods in Optimization</a></td>
                        <td>12</td>
                        <td>CS5107</td>
                        </tr>
                        <tr>
                        <td>CS516L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS516L.pdf' target='_blank;'>Data Science and Engineering</a></td>
                        <td>12</td>
                        <td>CS5109</td>
                        </tr>
                        <tr>
                        <td>CS516P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS516P.pdf' target='_blank;'>Data Science Programming Laboratory</a></td>
                        <td>12</td>
                        <td>CS5195</td>
                        </tr>
                        <tr>
                        <td>CS517L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS517L.pdf' target='_blank;'>Data Stream Analytics</a></td>
                        <td>12</td>
                        <td>CS5226</td>
                        </tr>
                        <tr>
                        <td>CS518L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS518L.pdf' target='_blank;'>Deep Learning</a></td>
                        <td>12</td>
                        <td>CS5223</td>
                        </tr>
                        <tr>
                        <td>CS519L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS519L.pdf' target='_blank;'>Machine Learning</a></td>
                        <td>12</td>
                        <td>CS5103</td>
                        </tr>
                        <tr>
                        <td>CS519P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS519P.pdf' target='_blank;'>Intelligent Systems Laboratory</a></td>
                        <td>12</td>
                        <td>CS5292</td>
                        </tr>
                        <tr>
                        <td>CS520L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS520L.pdf' target='_blank;'>Parallel Computing</a></td>
                        <td>12</td>
                        <td>CS5105</td>
                        </tr>
                        <tr>
                        <td>CS521L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS521L.pdf' target='_blank;'>Stochastic Decision Processes</a></td>
                        <td>12</td>
                        <td>CS5225</td>
                        </tr>
                        <tr>
                        <td>CS522L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS522L.pdf' target='_blank;'>Industrial Software Engineering</a></td>
                        <td>12</td>
                        <td>CS5206</td>
                        </tr>
                        <tr>
                        <td>CS523L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS523L.pdf' target='_blank;'>Distributed Systems</a></td>
                        <td>12</td>
                        <td>CS5208</td>
                        </tr>
                        <tr>
                        <td>CS524L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS524L.pdf' target='_blank;'>Algorithms for Big Data</a></td>
                        <td>14</td>
                        <td>CS5229</td>
                        </tr>
                        <tr>
                        <td>CS525L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS525L.pdf' target='_blank;'>Randomized Algorithms</a></td>
                        <td>14</td>
                        <td>CS5228</td>
                        </tr>
                        <tr>
                        <td>CS526L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS526L.pdf' target='_blank;'>Test and Verification of VLSI Systems</a></td>
                        <td>14</td>
                        <td>CS5227</td>
                        </tr>
                        <tr>
                        <td>CS527L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS527L.pdf' target='_blank;'>Cyber Security</a></td>
                        <td>15</td>
                        <td>CS5232</td>
                        </tr>
                        <tr>
                        <td>CS528L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS528L.pdf' target='_blank;'>Parallel Numerical Linear Algebra</a></td>
                        <td>15</td>
                        <td>CS5231</td>
                        </tr>
                        <tr>
                        <td>CS529L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS529L.pdf' target='_blank;'>Stochastic Network Optimization</a></td>
                        <td>15</td>
                        <td>CS5230</td>
                        </tr>
                        <tr>
                        <td>CS530L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS530L.pdf' target='_blank;'>Introduction to Blockchain Technology</a></td>
                        <td>16</td>
                        <td>CS5028</td>
                        </tr>
                        <tr>
                        <td>CS531L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS531L.pdf' target='_blank;'>Computer Systems Security</a></td>
                        <td>17</td>
                        <td>CS5029</td>
                        </tr>
                        <tr>
                        <td>CS532L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS532L.pdf' target='_blank;'>Probabilistic Machine Learning</a></td>
                        <td>18</td>
                        <td>CS5030</td>
                        </tr>
                        <tr>
                        <td>CS533L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS533L.pdf' target='_blank;'>Reinforcement Learning Algorithms</a></td>
                        <td>18</td>
                        <td>CS5224</td>
                        </tr>
                        <tr>
                        <td>CS534L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS534L.pdf' target='_blank;'>Foundations of Data Science</a></td>
                        <td>20</td>
                        <td>CS5233</td>
                        </tr>
                        <tr>
                        <td>CS535L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS535L.pdf' target='_blank;'>Data Science for Networks</a></td>
                        <td>21</td>
                        <td>CS5032</td>
                        </tr>
                        <tr>
                        <td>CS536L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS536L.pdf' target='_blank;'>Complex Networks</a></td>
                        <td>21</td>
                        <td>CS5031</td>
                        </tr>
                        <tr>
                        <td>CS537L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS537L.pdf' target='_blank;'>Introduction to Modern Cryptography</a></td>
                        <td>22</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>CS538L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS538L.pdf' target='_blank;'>Accelerating Sparse Computations</a></td>
                        <td>25</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>CS539L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS539L.pdf' target='_blank;'>Artificial Intelligence </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>CS540P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS540P.pdf' target='_blank;'>Intelligent Systems Laboratory </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>CS541L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS541L.pdf' target='_blank;'>Generative Software Engineering  </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>CS542L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS542L.pdf' target='_blank;'>Algorithms in Computational Biology  </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>CS543L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS543L.pdf' target='_blank;'>User Interface Design and Development  </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>CS601L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS601L.pdf' target='_blank;'>Big Data Systems</a></td>
                        <td>21</td>
                        <td>CS6101</td>
                        </tr>
                        <tr>
                        <td>CS601P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS601P.pdf' target='_blank;'>Big Data Systems Laboratory</a></td>
                        <td>21</td>
                        <td>CS6191</td>
                        </tr>
                        <tr>
                        <td>CS699L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS699L.pdf' target='_blank;'>Special Topics in Computer Science and Engineering I</a></td>
                        <td>11</td>
                        <td>CS6999/11</td>
                        </tr>
                        <tr>
                        <td>CS603L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS603L.pdf' target='_blank;'>Principles of Reinforcement Learning</a></td>
                        <td>17</td>
                        <td>CS6021</td>
                        </tr>
                        <tr>
                        <td>CS604L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS604L.pdf' target='_blank;'>Stochastic Dynamic Programming and Social Learning</a></td>
                        <td>17</td>
                        <td>CS6022</td>
                        </tr>
                        <tr>
                        <td>CS799L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/CSE/CS799L.pdf' target='_blank;'>Special Topics in Computer Science and Engineering II</a></td>
                        <td>11</td>
                        <td>CS7999/11</td>
                        </tr>
                    </tbody>
                </table>`
        },

        {
            id: 'headingEight',
            question: 'Electrical Engineering',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                        <tr>
                        <th>Course Code <br>(Since July, 2022)</th>
                        <th>Course Title</th>
                        <th>Approved In <br>Senate</th>
                        <th>Course Code<br> (Prior to July, 2022)</th>
                        </tr>
                        <tr>
                        <td>EE201L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE201L.pdf' target='_blank;'>Electric Circuits and Networks</a></td>
                        <td>8</td>
                        <td>EE2202</td>
                        </tr>
                        <tr>
                        <td>EE202M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE202M.pdf' target='_blank;'>Solid State Devices</a></td>
                        <td>8</td>
                        <td>EE2204</td>
                        </tr>
                        <tr>
                        <td>EE203L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE203L.pdf' target='_blank;'>Engineering Electromagnetics</a></td>
                        <td>16</td>
                        <td>EE2208</td>
                        </tr>
                        <tr>
                        <td>EE204M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE204M.pdf' target='_blank;'>Digital Signal Processing</a></td>
                        <td>8</td>
                        <td>EE2206</td>
                        </tr>
                        <tr>
                        <td>EE205L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE205L.pdf' target='_blank;'>Signals and Systems</a></td>
                        <td>8</td>
                        <td>EE2103</td>
                        </tr>
                        <tr>
                        <td>EE206L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE206L.pdf' target='_blank;'>Digital Systems</a></td>
                        <td>8</td>
                        <td>CS/EE2101</td>
                        </tr>
                        <tr>
                        <td>EE206P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE206P.pdf' target='_blank;'>Digital Systems Laboratory</a></td>
                        <td>8</td>
                        <td>CS/EE2191</td>
                        </tr>
                        <tr>
                        <td>EE207P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE207P.pdf' target='_blank;'>Analog Circuits Laboratory </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE207L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE207L.pdf' target='_blank;'>Analog Circuits </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE208L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE208L.pdf' target='_blank;'>Digital Systems </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE209P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE209P.pdf' target='_blank;'>Digital Signal Processing Laboratory </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE209L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE209L.pdf' target='_blank;'>Digital Signal Processing </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE210M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE210M.pdf' target='_blank;'>Semiconductor Devices </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE211L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE211L.pdf' target='_blank;'>Communication Systems </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE212M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE212M.pdf' target='_blank;'>Electronic Instrumentation and Measurement </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE213L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE213L.pdf' target='_blank;'>Electrical Circuits and Networks </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE301L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE301L.pdf' target='_blank;'>Analog Circuits</a></td>
                        <td>8</td>
                        <td>EE3101</td>
                        </tr>
                        <tr>
                        <td>EE301P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE301P.pdf' target='_blank;'>Analog Circuits Laboratory</a></td>
                        <td>8</td>
                        <td>EE3191</td>
                        </tr>
                        <tr>
                        <td>EE302L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE302L.pdf' target='_blank;'>Electrical Machines</a></td>
                        <td>8</td>
                        <td>EE3103</td>
                        </tr>
                        <tr>
                        <td>EE302P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE302P.pdf' target='_blank;'>Electrical Machines Laboratory</a></td>
                        <td>8</td>
                        <td>EE3193</td>
                        </tr>
                        <tr>
                        <td>EE303L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE303L.pdf' target='_blank;'>Control Engineering</a></td>
                        <td>8</td>
                        <td>EE3105</td>
                        </tr>
                        <tr>
                        <td>EE304L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE304L.pdf' target='_blank;'>Communication Systems</a></td>
                        <td>8</td>
                        <td>EE3107</td>
                        </tr>
                        <tr>
                        <td>EE305L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE305L.pdf' target='_blank;'>Power Systems</a></td>
                        <td>8</td>
                        <td>EE3202</td>
                        </tr>
                        <tr>
                        <td>EE306M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE306M.pdf' target='_blank;'>Principles of Measurement</a></td>
                        <td>8</td>
                        <td>EE3204</td>
                        </tr>
                        <tr>
                        <td>EE307L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE307L.pdf' target='_blank;'>Digital Communication</a></td>
                        <td>10</td>
                        <td>EE3021</td>
                        </tr>
                        <tr>
                        <td>EE308L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE308L.pdf' target='_blank;'>Engineering Electromagnetics </a></td>
                        <td> 28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE310L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE310L.pdf' target='_blank;'>Power Electronics </a></td>
                        <td> 28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE311L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE311L.pdf' target='_blank;'>Computer Organization and Processor Design </a></td>
                        <td> 28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>EE401L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE401L.pdf' target='_blank;'>Power Electronics</a></td>
                        <td>8</td>
                        <td>EE4101</td>
                        </tr>
                        <tr>
                        <td>EE403P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE403P.pdf' target='_blank;'>Control and Automation Laboratory</a></td>
                        <td>12</td>
                        <td>EE4191</td>
                        </tr>
                        <tr>
                        <td>EE404L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE404L.pdf' target='_blank;'>Electric Drives</a></td>
                        <td>12</td>
                        <td>EE4022</td>
                        </tr>
                        <tr>
                        <td>EE405L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE405L.pdf' target='_blank;'>Modeling and Control of Electric Machines</a></td>
                        <td>12</td>
                        <td>EE4023</td>
                        </tr>
                        <tr>
                        <td>EE501L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE501L.pdf' target='_blank;'>High Speed Devices and Circuits</a></td>
                        <td>2</td>
                        <td>EE5107</td>
                        </tr>
                        <tr>
                        <td>EE502L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE502L.pdf' target='_blank;'>Image and Video Processing</a></td>
                        <td>2</td>
                        <td>EE5101</td>
                        </tr>
                        <tr>
                        <td>EE503L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE503L.pdf' target='_blank;'>Linear Dynamical Systems</a></td>
                        <td>2</td>
                        <td>EE5102</td>
                        </tr>
                        <tr>
                        <td>EE504L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE504L.pdf' target='_blank;'>Non-Linear Control Systems</a></td>
                        <td>2</td>
                        <td>EE5104</td>
                        </tr>
                        <tr>
                        <td>EE505L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE505L.pdf' target='_blank;'>Optimal Control</a></td>
                        <td>2</td>
                        <td>EE5105</td>
                        </tr>
                        <tr>
                        <td>EE506L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE506L.pdf' target='_blank;'>Pattern Recognition and Machine learning</a></td>
                        <td>2</td>
                        <td>EE5106</td>
                        </tr>
                        <tr>
                        <td>EE507L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE507L.pdf' target='_blank;'>Computer Vision</a></td>
                        <td>3</td>
                        <td>EE5113</td>
                        </tr>
                        <tr>
                        <td>EE507P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE507P.pdf' target='_blank;'>Computer Vision Laboratory</a></td>
                        <td>6</td>
                        <td>EE5294</td>
                        </tr>
                        <tr>
                        <td>EE508L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE508L.pdf' target='_blank;'>Machine Learning for Image Processing</a></td>
                        <td>4</td>
                        <td>EE5024</td>
                        </tr>
                        <tr>
                        <td>EE509L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE509L.pdf' target='_blank;'>Communication Networks</a></td>
                        <td>5</td>
                        <td>EE5022</td>
                        </tr>
                        <tr>
                        <td>EE509P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE509P.pdf' target='_blank;'>Communication Networks&nbsp; Laboratory</a></td>
                        <td>8</td>
                        <td>EE5292</td>
                        </tr>
                        <tr>
                        <td>EE510L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE510L.pdf' target='_blank;'>Advanced Communication</a></td>
                        <td>6</td>
                        <td>EE5202</td>
                        </tr>
                        <tr>
                        <td>EE510P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE510P.pdf' target='_blank;'>Advanced Communications Lab</a></td>
                        <td>6</td>
                        <td>EE5292</td>
                        </tr>
                        <tr>
                        <td>EE511L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE511L.pdf' target='_blank;'>Information Theory and Coding</a></td>
                        <td>6</td>
                        <td>EE5025</td>
                        </tr>
                        <tr>
                        <td>EE512L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE512L.pdf' target='_blank;'>Multivariable Feedback Control</a></td>
                        <td>6</td>
                        <td>EE5026</td>
                        </tr>
                        <tr>
                        <td>EE513L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE513L.pdf' target='_blank;'>Statistical Signal Processing</a></td>
                        <td>6</td>
                        <td>EE5204</td>
                        </tr>
                        <tr>
                        <td>EE514L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE514L.pdf' target='_blank;'>CAD for VLSI Systems</a></td>
                        <td>7</td>
                        <td>EE5028</td>
                        </tr>
                        <tr>
                        <td>EE515L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE515L.pdf' target='_blank;'>Linear Integrated Circuits Theory and Applications</a></td>
                        <td>7</td>
                        <td>EE5027</td>
                        </tr>
                        <tr>
                        <td>EE516L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE516L.pdf' target='_blank;'>Medical Imaging</a></td>
                        <td>8</td>
                        <td>EE5029</td>
                        </tr>
                        <tr>
                        <td>EE517L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE517L.pdf' target='_blank;'>Transducers</a></td>
                        <td>8</td>
                        <td>EE5030</td>
                        </tr>
                        <tr>
                        <td>EE518L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE518L.pdf' target='_blank;'>Introduction to Integrated Photonics</a></td>
                        <td>9</td>
                        <td>EE5031</td>
                        </tr>
                        <tr>
                        <td>EE519L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE519L.pdf' target='_blank;'>Modeling and Control of Cyber-Physical Systems</a></td>
                        <td>9</td>
                        <td>EE5032</td>
                        </tr>
                        <tr>
                        <td>EE520L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE520L.pdf' target='_blank;'>Compound Semiconductor Devices</a></td>
                        <td>10</td>
                        <td>EE5033</td>
                        </tr>
                        <tr>
                        <td>EE521M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE521M.pdf' target='_blank;'>Embedded Systems</a></td>
                        <td>11</td>
                        <td>EE5035</td>
                        </tr>
                        <tr>
                        <td>EE522L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE522L.pdf' target='_blank;'>VLSI Circuits for Signal Processing</a></td>
                        <td>11</td>
                        <td>EE5037</td>
                        </tr>
                        <tr>
                        <td>EE523L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE523L.pdf' target='_blank;'>Wireless Communication</a></td>
                        <td>11</td>
                        <td style="font-weight: 400;" width="145">EE5103</td>
                        </tr>
                        <tr>
                        <td>EE523P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE523P.pdf' target='_blank;'>Wireless Communication Laboratory</a></td>
                        <td>11</td>
                        <td style="font-weight: 400;" width="145">EE5193</td>
                        </tr>
                        <tr>
                        <td>EE524L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE524L.pdf' target='_blank;'>Nanoelectronic Devices</a></td>
                        <td>12</td>
                        <td>EE5038</td>
                        </tr>
                        <tr>
                        <td>EE525L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE525L.pdf' target='_blank;'>Probabilistic Graphical Models</a></td>
                        <td>12</td>
                        <td>EE5040</td>
                        </tr>
                        <tr>
                        <td>EE526L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE526L.pdf' target='_blank;'>Speech Signal Processing</a></td>
                        <td>12</td>
                        <td>EE5034</td>
                        </tr>
                        <tr>
                        <td>EE527L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE527L.pdf' target='_blank;'>Advanced Signal Analysis and Processing</a></td>
                        <td>12</td>
                        <td>EE5101</td>
                        </tr>
                        <tr>
                        <td>EE527P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE527P.pdf' target='_blank;'>Advanced Signal Analysis and Processing Laboratory</a></td>
                        <td>12</td>
                        <td>EE5191</td>
                        </tr>
                        <tr>
                        <td>EE528L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE528L.pdf' target='_blank;'>Advanced Engineering Electromagnetics</a></td>
                        <td>16</td>
                        <td>EE5053</td>
                        </tr>
                        <tr>
                        <td>EE529L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE529L.pdf' target='_blank;'>Advanced Microwave Engineering</a></td>
                        <td>16</td>
                        <td>EE5052</td>
                        </tr>
                        <tr>
                        <td>EE530L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE530L.pdf' target='_blank;'>Analog VLSI Design</a></td>
                        <td>16</td>
                        <td>EE5041</td>
                        </tr>
                        <tr>
                        <td>EE531L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE531L.pdf' target='_blank;'>Antennas and Wave Propagation</a></td>
                        <td>16</td>
                        <td>EE5042</td>
                        </tr>
                        <tr>
                        <td>EE532L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE532L.pdf' target='_blank;'>Deep Learning for Healthcare</a></td>
                        <td>16</td>
                        <td>EE5043</td>
                        </tr>
                        <tr>
                        <td>EE533P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE533P.pdf' target='_blank;'>Device Fabrication and Characterization Laboratory</a></td>
                        <td>16</td>
                        <td>EE5298</td>
                        </tr>
                        <tr>
                        <td>EE534P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE534P.pdf' target='_blank;'>Device Simulation Laboratory</a></td>
                        <td>16</td>
                        <td>EE5195</td>
                        </tr>
                        <tr>
                        <td>EE535L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE535L.pdf' target='_blank;'>Digital VLSI Design</a></td>
                        <td>16</td>
                        <td>EE5109</td>
                        </tr>
                        <tr>
                        <td>EE536P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE536P.pdf' target='_blank;'>FPGA Laboratory</a></td>
                        <td>16</td>
                        <td>EE5296</td>
                        </tr>
                        <tr>
                        <td>EE537L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE537L.pdf' target='_blank;'>Fundamentals of Multiple Antenna Wireless Communications</a></td>
                        <td>16</td>
                        <td>EE5044</td>
                        </tr>
                        <tr>
                        <td>EE538L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE538L.pdf' target='_blank;'>Introduction to Smart Grid Technology</a></td>
                        <td>16</td>
                        <td>EE5045</td>
                        </tr>
                        <tr>
                        <td>EE539L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE539L.pdf' target='_blank;'>Microwave Theory and Techniques</a></td>
                        <td>16</td>
                        <td>EE5046</td>
                        </tr>
                        <tr>
                        <td>EE540L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE540L.pdf' target='_blank;'>MOS Device Modelling and Characterization</a></td>
                        <td>16</td>
                        <td>EE5023</td>
                        </tr>
                        <tr>
                        <td>EE541L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE541L.pdf' target='_blank;'>Network Economics</a></td>
                        <td>16</td>
                        <td>EE5047</td>
                        </tr>
                        <tr>
                        <td>EE542L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE542L.pdf' target='_blank;'>Physics and Modeling of Semiconductor Devices</a></td>
                        <td>16</td>
                        <td>EE5039</td>
                        </tr>
                        <tr>
                        <td>EE543L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE543L.pdf' target='_blank;'>RF and Mixed Signal Design</a></td>
                        <td>16</td>
                        <td>EE5049</td>
                        </tr>
                        <tr>
                        <td>EE544L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE544L.pdf' target='_blank;'>RF Microelectronics</a></td>
                        <td>16</td>
                        <td>EE5048</td>
                        </tr>
                        <tr>
                        <td>EE545M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE545M.pdf' target='_blank;'>RF-CAD Lab-based Project</a></td>
                        <td>16</td>
                        <td>EE5127</td>
                        </tr>
                        <tr>
                        <td>EE546L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE546L.pdf' target='_blank;'>Stochastic Geometry for Wireless Networks</a></td>
                        <td>16</td>
                        <td>EE5051</td>
                        </tr>
                        <tr>
                        <td>EE547L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE547L.pdf' target='_blank;'>VLSI Fabrication Principles</a></td>
                        <td>16</td>
                        <td>EE5036</td>
                        </tr>
                        <tr>
                        <td>EE548L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE548L.pdf' target='_blank;'>Antenna Theory and Design</a></td>
                        <td>17</td>
                        <td>EE5054</td>
                        </tr>
                        <tr>
                        <td>EE549L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE549L.pdf' target='_blank;'>Microwave Integrated Circuits</a></td>
                        <td>17</td>
                        <td>EE5055</td>
                        </tr>
                        <tr>
                        <td>EE550L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE550L.pdf' target='_blank;'>RF Transceiver Design</a></td>
                        <td>17</td>
                        <td>EE5056</td>
                        </tr>
                        <tr>
                        <td>EE551L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE551L.pdf' target='_blank;'>Theory and Design of Gyrotrons</a></td>
                        <td>17</td>
                        <td>EE5057</td>
                        </tr>
                        <tr>
                        <td>EE552L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE552L.pdf' target='_blank;'>Advanced Power Electronics</a></td>
                        <td>19</td>
                        <td>EE5058</td>
                        </tr>
                        <tr>
                        <td>EE553L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE553L.pdf' target='_blank;'>Modeling and Control of Autonomous Mobile Robots</a></td>
                        <td>19</td>
                        <td>EE5059</td>
                        </tr>
                        <tr>
                        <td>EE554P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE554P.pdf' target='_blank;'>Image Processing Laboratory</a></td>
                        <td>5</td>
                        <td>EE5193</td>
                        </tr>
                        <tr>
                        <td>EE555L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE555L.pdf' target='_blank;'>Deep Learning for Computer Vision</a></td>
                        <td>2</td>
                        <td>EE5103</td>
                        </tr>
                        <tr>
                        <td>EE556L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE556L.pdf' target='_blank;'>Wireless Communication</a></td>
                        <td>4</td>
                        <td>EE5022</td>
                        </tr>
                        <tr>
                        <td>EE557P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE557P.pdf' target='_blank;'>RF-CAD and Circuits Laboratory</a></td>
                        <td>21</td>
                        <td>EE5194</td>
                        </tr>
                        <tr>
                        <td>EE558P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE558P.pdf' target='_blank;'>Advanced Microwave Laboratory</a></td>
                        <td>21</td>
                        <td>EE5192</td>
                        </tr>
                        <tr>
                        <td>EE559M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE559M.pdf' target='_blank;'>Advanced Topics of RF-CAD Lab based Project</a></td>
                        <td>23</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>EE560L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE560L.pdf' target='_blank;'>Computational Electromagnetics</a></td>
                        <td>23</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>EE561L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE561L.pdf' target='_blank;'>Fiber Optic Systems</a></td>
                        <td>23</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>EE562L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE562L.pdf' target='_blank;'>Foundations of Metamaterials and Plasmonics</a></td>
                        <td>23</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>EE563L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE563L.pdf' target='_blank;'>Quantum Information Theory</a></td>
                        <td>25</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>EE564L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE564L.pdf' target='_blank;'>Power Semiconductor Devices </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>EE565L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE565L.pdf' target='_blank;'>Machine Learning for Wireless Communications </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>EE566L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE566L.pdf' target='_blank;'>Multiple Antenna Communication for 5G and beyond </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>EE601L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE601L.pdf' target='_blank;'>Deep Learning: Theory and Applications</a></td>
                        <td>7</td>
                        <td>EE6021</td>
                        </tr>
                        <tr>
                        <td>EE602L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE602L.pdf' target='_blank;'>Network Information Theory</a></td>
                        <td>7</td>
                        <td>EE6022</td>
                        </tr>
                        <tr>
                        <td>EE603L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE603L.pdf' target='_blank;'>Robotics and Automation</a></td>
                        <td>8</td>
                        <td>EE6023</td>
                        </tr>
                        <tr>
                        <td>EE604L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/EE/EE604L.pdf' target='_blank;'>Queueing Theory</a></td>
                        <td>9</td>
                        <td>EE6024</td>
                        </tr>
                        </tbody>
                    </table>`
        }

        ,

        {
            id: 'headingnine',
            question: 'Humanities and Social Sciences',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                        <tr>
                        <th>Course Code <br>(Since July, 2022)</th>
                        <th>Course Title</th>
                        <th>Approved In <br>Senate</th>
                        <th>Course Code<br> (Prior to July, 2022)</th>
                        </tr>
                        <tr>
                        <td>HS101N</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS101N.pdf' target='_blank;'>Proficiency in English</a></td>
                        <td>4</td>
                        <td>HS1101</td>
                        </tr>
                        <tr>
                        <td>HS102N</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS102N.pdf' target='_blank;'>Basic Course in German</a></td>
                        <td>6</td>
                        <td>HS1103</td>
                        </tr>
                        <tr>
                        <td>HS103N</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS103N.pdf' target='_blank;'>Basic Course in Japanese</a></td>
                        <td>6</td>
                        <td>HS1105</td>
                        </tr>
                        <tr>
                        <td>HS104N</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS104N.pdf' target='_blank;'>Basic Course in Sanskrit</a></td>
                        <td>6</td>
                        <td>HS1107</td>
                        </tr>
                        <tr>
                        <td>HS105N</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS105N.pdf' target='_blank;'>Basic Course in Spanish</a></td>
                        <td>9</td>
                        <td>HS1109</td>
                        </tr>
                        <tr>
                        <td>HS201L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS201L.pdf' target='_blank;'>Introduction to the Science of Language</a></td>
                        <td>2</td>
                        <td>HS2020</td>
                        </tr>
                        <tr>
                        <td>HS202L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS202L.pdf' target='_blank;'>International Trade and Finance</a></td>
                        <td>3</td>
                        <td>HS2030</td>
                        </tr>
                        <tr>
                        <td>HS203L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS203L.pdf' target='_blank;'>The Indian Economy</a></td>
                        <td>3</td>
                        <td>HS2211</td>
                        </tr>
                        <tr>
                        <td>HS204L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS204L.pdf' target='_blank;'>Introduction to Political Economy</a></td>
                        <td>7</td>
                        <td>HS2021</td>
                        </tr>
                        <tr>
                        <td>HS205L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS205L_English for Communication.pdf' target='_blank;'>English for Communication</a></td>
                        <td>8</td>
                        <td>HS2022</td>
                        </tr>
                        <tr>
                        <td>HS206L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS206L.pdf' target='_blank;'>Organizational Behaviour</a></td>
                        <td>8</td>
                        <td>HS2024</td>
                        </tr>
                        <tr>
                        <td>HS207L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS207L.pdf' target='_blank;'>Introduction to Philosophy</a></td>
                        <td>8</td>
                        <td>HS2023</td>
                        </tr>
                        <tr>
                        <td>HS208L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS208L.pdf' target='_blank;'>Public Policy in India</a></td>
                        <td>22</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>HS209L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS209L.pdf' target='_blank;'>Introduction to Philosophy</a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>HS301L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS301L.pdf' target='_blank;'>Environmental and Resource Economics</a></td>
                        <td>2</td>
                        <td>HS3020</td>
                        </tr>
                        <tr>
                        <td>HS302L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS302L_Indian Literature Text and Performance.pdf' target='_blank;'>Indian Literature: Text and Performance</a></td>
                        <td>2</td>
                        <td>HS3040</td>
                        </tr>
                        <tr>
                        <td>HS303L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS303L.pdf' target='_blank;'>Reading Indian Cinema</a></td>
                        <td>2</td>
                        <td>HS3050</td>
                        </tr>
                        <tr>
                        <td>HS304L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS304L.pdf' target='_blank;'>Science, Technology and Society</a></td>
                        <td>2</td>
                        <td>HS3030</td>
                        </tr>
                        <tr>
                        <td>HS305L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS305L.pdf' target='_blank;'>Foundations to Indian National Movement</a></td>
                        <td>6</td>
                        <td>HS3060</td>
                        </tr>
                        <tr>
                        <td>HS306L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS306L.pdf' target='_blank;'>Leadership and Team Management</a></td>
                        <td>6</td>
                        <td>HS3221</td>
                        </tr>
                        <tr>
                        <td>HS307L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS307L.pdf' target='_blank;'>Basics of Microeconomics</a></td>
                        <td>7</td>
                        <td>HS3021</td>
                        </tr>
                        <tr>
                        <td>HS308L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS308L.pdf' target='_blank;'>Introduction to Financial Management</a></td>
                        <td>8</td>
                        <td>HS3023</td>
                        </tr>
                        <tr>
                        <td>HS309L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS309L.pdf' target='_blank;'>Principles of Economics</a></td>
                        <td>8</td>
                        <td>HS3022</td>
                        </tr>
                        <tr>
                        <td>HS310L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS310L.pdf' target='_blank;'>Modern Literature</a></td>
                        <td>23</td>
                        <td>NA</td>
                        </tr>
                        <tr>
                        <td>HS311L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS311L.pdf' target='_blank;'>Colonialism and Anti- Colonial Thought</a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>HS401L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS401L.pdf' target='_blank;'>Professional Ethics</a></td>
                        <td>7</td>
                        <td>HS4202</td>
                        </tr>
                        <tr>
                        <td>HS402L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS402L.pdf' target='_blank;'>Introduction to Public Speaking</a></td>
                        <td>6</td>
                        <td>HS4121</td>
                        </tr>
                        <tr>
                        <td>HS403L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS403L.pdf' target='_blank;'>Organizational Psychology: Theory and Practice</a></td>
                        <td>6</td>
                        <td>HS4021</td>
                        </tr>
                        <tr>
                        <td>HS404L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS404L.pdf' target='_blank;'>Academic Writing</a></td>
                        <td>6</td>
                        <td>HS4122</td>
                        </tr>
                        <tr>
                        <td>HS405L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS405L.pdf' target='_blank;'>Indian Political Thought</a></td>
                        <td>8</td>
                        <td>HS4022</td>
                        </tr>
                        <tr>
                        <td>HS406L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS406L.pdf' target='_blank;'>Professional Ethics</a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>HS501L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS501L.pdf' target='_blank;'>Sustainability Science and Governance</a></td>
                        <td>19</td>
                        <td>HS5021</td>
                        </tr>
                        <tr>
                        <td>HS502L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS502L.pdf' target='_blank;'>Financial Statement Analysis</a></td>
                        <td>20</td>
                        <td>HS5022</td>
                        </tr>
                        <tr>
                        <td>HS503L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS503L.pdf' target='_blank;'>Introduction to Data Analytics -Methods</a></td>
                        <td>21</td>
                        <td>HS5023</td>
                        </tr>
                        <tr>
                        <td>HS504L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS504L.pdf' target='_blank;'>Biodiversity Conservation and Sustainability</a></td>
                        <td>21</td>
                        <td>HS5024</td>
                        </tr>
                        <tr>
                        <td>HS505L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS505L.pdf' target='_blank;'>Communication for Effective Leadership - I</a></td>
                        <td>21</td>
                        <td>HS5025</td>
                        </tr>
                        <tr>
                        <td>HS506L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS506L.pdf' target='_blank;'>Communication for Effective Leadership - II</a></td>
                        <td>21</td>
                        <td>HS5026</td>
                        </tr>
                        <tr>
                        <td>HS507L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS507L.pdf' target='_blank;'>Crises, Pandemics and Policy Responses</a></td>
                        <td>21</td>
                        <td>HS5027</td>
                        </tr>
                        <tr>
                        <td>HS508L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS508L.pdf' target='_blank;'>Economics for Public Policy</a></td>
                        <td>21</td>
                        <td>HS5028</td>
                        </tr>
                        <tr>
                        <td>HS509L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS509L.pdf' target='_blank;'>Ethics and Public Policy</a></td>
                        <td>21</td>
                        <td>HS5029</td>
                        </tr>
                        <tr>
                        <td>HS510L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS510L.pdf' target='_blank;'>Introduction to Energy and Environmental Policy</a></td>
                        <td>21</td>
                        <td>HS5030</td>
                        </tr>
                        <tr>
                        <td>HS511L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS511L.pdf' target='_blank;'>Introduction to Program Evaluation</a></td>
                        <td>21</td>
                        <td>HS5031</td>
                        </tr>
                        <tr>
                        <td>HS512L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS512L.pdf' target='_blank;'>Public Administration, Public Policy and Governance</a></td>
                        <td>21</td>
                        <td>HS5032</td>
                        </tr>
                        <tr>
                        <td>HS513L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS513L.pdf' target='_blank;'>Public Finance</a></td>
                        <td>21</td>
                        <td>HS5033</td>
                        </tr>
                        <tr>
                        <td>HS514L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS514L.pdf' target='_blank;'>Public Organization and Management</a></td>
                        <td>21</td>
                        <td>HS5034</td>
                        </tr>
                        <tr>
                        <td>HS515L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS515L.pdf' target='_blank;'>Statistical Techniques for Public Policy</a></td>
                        <td>21</td>
                        <td>HS5035</td>
                        </tr>
                        <tr>
                        <td>HS516L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS516L.pdf' target='_blank;'>Research Design and Qualitative Methods</a></td>
                        <td>21</td>
                        <td>HS5036</td>
                        </tr>
                        <tr>
                        <td>HS517L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS517L.pdf' target='_blank;'>Social Justice and Human Rights</a></td>
                        <td>21</td>
                        <td>HS5037</td>
                        </tr>
                        <tr>
                        <td>HS518L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS518L.pdf' target='_blank;'>Sustainable Urban Infrastructure</a></td>
                        <td>21</td>
                        <td>HS5038</td>
                        </tr>
                        <tr>
                        <td>HS519L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS519L.pdf' target='_blank;'>Project Management</a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>HS520L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS520L.pdf' target='_blank;'>Supply Chain Management</a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>HS601L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS601L.pdf' target='_blank;'>Advanced Literary Criticism</a></td>
                        <td>2</td>
                        <td>HS6101</td>
                        </tr>
                        <tr>
                        <td>HS602L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS602L.pdf' target='_blank;'>Cultural Studies</a></td>
                        <td>2</td>
                        <td>HS6102</td>
                        </tr>
                        <tr>
                        <td>HS603L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS603L.pdf' target='_blank;'>Indian Literature in Translation</a></td>
                        <td>2</td>
                        <td>HS6103</td>
                        </tr>
                        <tr>
                        <td>HS604L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS604L.pdf' target='_blank;'>Indian Poetics</a></td>
                        <td>2</td>
                        <td>HS6104</td>
                        </tr>
                        <tr>
                        <td>HS605L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS605L.pdf' target='_blank;'>Financial Institutions and Markets</a></td>
                        <td>6</td>
                        <td>HS6022</td>
                        </tr>
                        <tr>
                        <td>HS606L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS606L.pdf' target='_blank;'>Introduction to Behavioral Economics</a></td>
                        <td>6</td>
                        <td>HS6021</td>
                        </tr>
                        <tr>
                        <td>HS607L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS607L.pdf' target='_blank;'>Indian Metaphysics</a></td>
                        <td>8</td>
                        <td>HS6023</td>
                        </tr>
                        <tr>
                        <td>HS608L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS608L.pdf' target='_blank;'>Modern Indian Philosophy</a></td>
                        <td>8</td>
                        <td>HS6024</td>
                        </tr>
                        <tr>
                        <td>HS609L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS609L.pdf' target='_blank;'>Philosophical Discourse of Modernity</a></td>
                        <td>8</td>
                        <td>HS6025</td>
                        </tr>
                        <tr>
                        <td>HS610L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS610L.pdf' target='_blank;'>Philosophy, Politics and Society</a></td>
                        <td>8</td>
                        <td>HS6026</td>
                        </tr>
                        <tr>
                        <td>HS611L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS611L.pdf' target='_blank;'>New Media and Digital Culture</a></td>
                        <td>9</td>
                        <td>HS6027</td>
                        </tr>
                        <tr>
                        <td>HS612L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS612L.pdf' target='_blank;'>Behavioral Finance</a></td>
                        <td>10</td>
                        <td>HS6028</td>
                        </tr>
                        <tr>
                        <td>HS613L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS613L.pdf' target='_blank;'>Fundamentals of Econometrics</a></td>
                        <td>10</td>
                        <td>HS6029</td>
                        </tr>
                        <tr>
                        <td>HS614L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS614L.pdf' target='_blank;'>Technical Communication</a></td>
                        <td>10</td>
                        <td>HS6105</td>
                        </tr>
                        <tr>
                        <td>HS615L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS615L.pdf' target='_blank;'>Corporate Governance</a></td>
                        <td>12</td>
                        <td>HS6030</td>
                        </tr>
                        <tr>
                        <td>HS616L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS616L.pdf' target='_blank;'>Sustainable Human Resource Management</a></td>
                        <td>19</td>
                        <td>HS6031</td>
                        </tr>
                        <tr>
                        <td>HS617L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS617L.pdf' target='_blank;'>Conflict Theory</a></td>
                        <td>20</td>
                        <td>HS6032</td>
                        </tr>
                        <tr>
                        <td>HS618L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS618L.pdf' target='_blank;'>Introduction to Migration Studies in Literature</a></td>
                        <td>20</td>
                        <td>HS6033</td>
                        </tr>
                        <tr>
                        <td>HS619L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS619L.pdf' target='_blank;'>Introduction to Data Analytics -Tools</a></td>
                        <td>21</td>
                        <td>HS6034</td>
                        </tr>
                        <tr>
                        <td>HS620L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS620L.pdf' target='_blank;'>Communication for Effective Leadership - III</a></td>
                        <td>21</td>
                        <td>HS6035</td>
                        </tr>
                        <tr>
                        <td>HS621L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS621L.pdf' target='_blank;'>Indian Economic Experiences</a></td>
                        <td>21</td>
                        <td>HS6036</td>
                        </tr>
                        <tr>
                        <td>HS622L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS622L.pdf' target='_blank;'>Introduction to Theories of Development</a></td>
                        <td>21</td>
                        <td>HS6037</td>
                        </tr>
                        <tr>
                        <td>HS623L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS623L.pdf' target='_blank;'>Politics of Environmental Policy-making Processes</a></td>
                        <td>21</td>
                        <td>HS6038</td>
                        </tr>
                        <tr>
                        <td>HS624L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS624L.pdf' target='_blank;'>Sustainable Finance</a></td>
                        <td>21</td>
                        <td>HS6039</td>
                        </tr>
                        <tr>
                        <td>HS625L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS625L.pdf' target='_blank;'>Time Series Modelling</a></td>
                        <td>21</td>
                        <td>HS6040</td>
                        </tr>
                        <tr>
                        <td>HS626L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS626L.pdf' target='_blank;'>Gender, Crime, and Popular Media</a></td>
                        <td>23</td>
                        <td>NA</td>
                        </tr>
                        <tr>
                        <td>HS701L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS701L.pdf' target='_blank;'>Advanced Environmental and Resource Economics</a></td>
                        <td>3</td>
                        <td>HS7105</td>
                        </tr>
                        <tr>
                        <td>HS702L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS702L.pdf' target='_blank;'>Applied Econometrics</a></td>
                        <td>3</td>
                        <td>HS7103</td>
                        </tr>
                        <tr>
                        <td>HS703L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS703L.pdf' target='_blank;'>Development Economics</a></td>
                        <td>3</td>
                        <td>HS7101</td>
                        </tr>
                        <tr>
                        <td>HS704L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS704L.pdf' target='_blank;'>Economics of Climate Change</a></td>
                        <td>3</td>
                        <td>HS7202</td>
                        </tr>
                        <tr>
                        <td>HS705L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS705L.pdf' target='_blank;'>Microeconomics</a></td>
                        <td>3</td>
                        <td>HS7204</td>
                        </tr>
                        <tr>
                        <td>HS706L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS706L.pdf' target='_blank;'>Program Evaluation</a></td>
                        <td>3</td>
                        <td>HS7206</td>
                        </tr>
                        <tr>
                        <td>HS707L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS707L_Advanced Organizational Behaviour.pdf' target='_blank;'>Advanced Organizational Behaviour</a></td>
                        <td>8</td>
                        <td>HS7021</td>
                        </tr>
                        <tr>
                        <td>HS708L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS708L_Data Analysis for Management.pdf' target='_blank;'>Data Analysis for Management</a></td>
                        <td>8</td>
                        <td>HS7022</td>
                        </tr>
                        <tr>
                        <td>HS709L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS709L.pdf' target='_blank;'>Human Resource Management</a></td>
                        <td>8</td>
                        <td>HS7023</td>
                        </tr>
                        <tr>
                        <td>HS710L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/HSS/HS710L.pdf' target='_blank;'>Organization Structure and Design</a></td>
                        <td>8</td>
                        <td>HS7024</td>
                        </tr>
                        </tbody>
                    </table>`
        }


        ,

        {
            id: 'headingten',
            question: 'Mathematics and Statistics',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                    <tr>
                    <th>Course Code <br>(Since July, 2022)</th>
                    <th>Course Title</th>
                    <th>Approved In <br>Senate</th>
                    <th>Course Code<br> (Prior to July, 2022)</th>
                    </tr>
                    <tr>
                    <td>MA101L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA101L.pdf' target='_blank;'>Calculus</a></td>
                    <td>4</td>
                    <td>MA1101</td>
                    </tr>
                    <tr>
                    <td>MA102L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA102L.pdf' target='_blank;'>Differential Equations and Matrices</a></td>
                    <td>4</td>
                    <td>MA1202</td>
                    </tr>
                    <tr>
                    <td>MA103L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA103L.pdf' target='_blank;'>Engineering Mathematics-I</a></td>
                    <td>26</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>MA104L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA104L.pdf' target='_blank;'>Engineering Mathematics-II</a></td>
                    <td>26</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>MA201L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA201L.pdf' target='_blank;'>Linear Algebra</a></td>
                    <td>12</td>
                    <td>MA2021</td>
                    </tr>
                    <tr>
                    <td>MA202L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA202L.pdf' target='_blank;'>Complex Variables&nbsp;</a></td>
                    <td>7</td>
                    <td>MA2022</td>
                    </tr>
                    <tr>
                    <td>MA203L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA203L.pdf' target='_blank;'>Numerical Analysis</a></td>
                    <td>7</td>
                    <td>MA2024</td>
                    </tr>
                    <tr>
                    <td>MA204L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA204L.pdf' target='_blank;'>Probability and Statistics&nbsp;</a></td>
                    <td>9</td>
                    <td>MA2023</td>
                    </tr>
                    <tr>
                    <td>MA205L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA205L.pdf' target='_blank;'>Statistics and Random Processes</a></td>
                    <td>9</td>
                    <td>MA2023</td>
                    </tr>
                    <tr>
                    <td>MA206L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA206L.pdf' target='_blank;'>Numerical Methods</a></td>
                    <td>9</td>
                    <td>MA2023</td>
                    </tr>
                    <tr>
                    <td>MA501L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA501L.pdf' target='_blank;'>Linear Algebra for Engineers</a></td>
                    <td>12</td>
                    <td>MA5021</td>
                    </tr>
                    <tr>
                    <td>MA502L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA502L.pdf' target='_blank;'>Differential Equations for Engineers</a></td>
                    <td>12</td>
                    <td>MA5023</td>
                    </tr>
                    <tr>
                    <td>MA503L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA503L.pdf' target='_blank;'>Probability Theory for Engineers</a></td>
                    <td>12</td>
                    <td>MA5022</td>
                    </tr>
                    <tr>
                    <td>MA504L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA504L.pdf' target='_blank;'>Statistical Methods for Engineers</a></td>
                    <td>3</td>
                    <td>MA5103</td>
                    </tr>
                    <tr>
                    <td>MA505L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA505L.pdf' target='_blank;'>Discrete Mathematics</a></td>
                    <td>7</td>
                    <td>MA5111</td>
                    </tr>
                    <tr>
                    <td>MA506L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA506L_Linear Algebra.pdf' target='_blank;'>Linear Algebra</a></td>
                    <td>7</td>
                    <td>MA5109</td>
                    </tr>
                    <tr>
                    <td>MA507P</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA507P.pdf' target='_blank;'>Programming Lab</a></td>
                    <td>7</td>
                    <td>MA5191</td>
                    </tr>
                    <tr>
                    <td>MA508L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA508L.pdf' target='_blank;'>Statistical Inference</a></td>
                    <td>7</td>
                    <td>MA5115</td>
                    </tr>
                    <tr>
                    <td>MA509L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA509L.pdf' target='_blank;'>Stochastic Processes and Time Series Analysis</a></td>
                    <td>7</td>
                    <td>MA5210</td>
                    </tr>
                    <tr>
                    <td>MA510L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA510L.pdf' target='_blank;'>Multivariable Calculus and Measure Theory</a></td>
                    <td>10</td>
                    <td>MA5202</td>
                    </tr>
                    <tr>
                    <td>MA511L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA511L.pdf' target='_blank;'>Ordinary Differential Equations</a></td>
                    <td>10</td>
                    <td>MA5204</td>
                    </tr>
                    <tr>
                    <td>MA512L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA512L.pdf' target='_blank;'>Probability Theory</a></td>
                    <td>10</td>
                    <td>MA5113</td>
                    </tr>
                    <tr>
                    <td>MA513L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA513L.pdf' target='_blank;'>Real Analysis</a></td>
                    <td>10</td>
                    <td>MA5107</td>
                    </tr>
                    <tr>
                    <td>MA514L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA514L.pdf' target='_blank;'>Regression Analysis</a></td>
                    <td>10</td>
                    <td>MA5208</td>
                    </tr>
                    <tr>
                    <td>MA515L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA515L.pdf' target='_blank;'>Algebra</a></td>
                    <td>7</td>
                    <td>MA5206</td>
                    </tr>
                    <tr>
                    <td>MA516L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA516L.pdf' target='_blank;'>Basic Graph Theory</a></td>
                    <td>26</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>MA517M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA517M.pdf' target='_blank;'>Basic Programming Laboratory</a></td>
                    <td>26</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>MA518L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA518L.pdf' target='_blank;'>Groups and Rings</a></td>
                    <td>26</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>MA519L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA519L.pdf' target='_blank;'>Sampling Theory</a></td>
                    <td>26</td>
                    <td> - </td>
                    </tr>

                    <tr>
                    <td>MA520L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA520L.pdf' target='_blank;'>Measure Theory </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>
                    <tr>
                    <td>MA521L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA521L.pdf' target='_blank;'>Multivariable Calculus  </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>
                    <tr>
                        <td>MA522M</td>
                        <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA522M.pdf' target='_blank;'>Data Science Programming Laboratory  </a></td>
                        <td>27</td>
                        <td>MA522P</td>
                    </tr>
                    <tr>
                    <td>MA523L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA523L.pdf' target='_blank;'>Stochastic Processes </a></td>
                    <td>27</td>
                    <td> - </td>
                    </tr>

                    <tr>
                    <td>MA601L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA601L.pdf' target='_blank;'>Complex Analysis</a></td>
                    <td>7</td>
                    <td>MA6105</td>
                    </tr>
                    <tr>
                    <td>MA602L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA602L.pdf' target='_blank;'>Sampling Theory and Design of Experiments</a></td>
                    <td>7</td>
                    <td>MA6107</td>
                    </tr>
                    <tr>
                    <td>MA603L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA603L.pdf' target='_blank;'>Multivariate Statistical Analysis</a></td>
                    <td>7</td>
                    <td>MA6109</td>
                    </tr>
                    <tr>
                    <td>MA604M</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA604M.pdf' target='_blank;'>Numerical Analysis</a></td>
                    <td>10</td>
                    <td>MA6204</td>
                    </tr>
                    <tr>
                    <td>MA606L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA606L.pdf' target='_blank;'>Bayesian Statistics</a></td>
                    <td>7</td>
                    <td>MA6029</td>
                    </tr>
                    <tr>
                    <td>MA607L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA607L.pdf' target='_blank;'>Fixed Point Theory</a></td>
                    <td>2</td>
                    <td>MA6102</td>
                    </tr>
                    <tr>
                    <td>MA608L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA608L.pdf' target='_blank;'>Functional Analysis</a></td>
                    <td>7</td>
                    <td>MA6022</td>
                    </tr>
                    <tr>
                    <td>MA609L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA609L.pdf' target='_blank;'>Linear Integral Equations</a></td>
                    <td>2</td>
                    <td>MA6101</td>
                    </tr>
                    <tr>
                    <td>MA610L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA610L.pdf' target='_blank;'>Non-parametric Statistics</a></td>
                    <td>7</td>
                    <td>MA6028</td>
                    </tr>
                    <tr>
                    <td>MA611L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA611L.pdf' target='_blank;'>Number Theory</a></td>
                    <td>7</td>
                    <td>MA6023</td>
                    </tr>
                    <tr>
                    <td>MA612L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA612L.pdf' target='_blank;'>Partial Differential Equations</a></td>
                    <td>7</td>
                    <td>MA6024</td>
                    </tr>
                    <tr>
                    <td>MA613L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA613L.pdf' target='_blank;'>Fractal Geometry</a></td>
                    <td>2</td>
                    <td>MA6103</td>
                    </tr>
                    <tr>
                    <td>MA614L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA614L.pdf' target='_blank;'>Topology</a></td>
                    <td>7</td>
                    <td>MA6021</td>
                    </tr>
                    <tr>
                    <td>MA615L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA615L.pdf' target='_blank;'>Generalized Linear Models</a></td>
                    <td>3</td>
                    <td>MA6202</td>
                    </tr>
                    <tr>
                    <td>MA616L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA616L.pdf' target='_blank;'>Biostatistics</a></td>
                    <td>12</td>
                    <td>MA6036</td>
                    </tr>
                    <tr>
                    <td>MA617L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA617L.pdf' target='_blank;'>Categorical Data Analysis</a></td>
                    <td>12</td>
                    <td>MA6031</td>
                    </tr>
                    <tr>
                    <td>MA618L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA618L.pdf' target='_blank;'>Continuum Mechanics</a></td>
                    <td>12</td>
                    <td>MA6025</td>
                    </tr>
                    <tr>
                    <td>MA619L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA619L.pdf' target='_blank;'>Functional Data Analysis</a></td>
                    <td>12</td>
                    <td>MA6033</td>
                    </tr>
                    <tr>
                    <td>MA620L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA620L.pdf' target='_blank;'>Lie Algebras</a></td>
                    <td>12</td>
                    <td>MA6037</td>
                    </tr>
                    <tr>
                    <td>MA621L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA621L.pdf' target='_blank;'>Mathematical Modelling</a></td>
                    <td>12</td>
                    <td>MA6026</td>
                    </tr>
                    <tr>
                    <td>MA622L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA622L.pdf' target='_blank;'>Operations Research</a></td>
                    <td>12</td>
                    <td>MA6034</td>
                    </tr>
                    <tr>
                    <td>MA623L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA623L.pdf' target='_blank;'>Representation Theory</a></td>
                    <td>12</td>
                    <td>MA6038</td>
                    </tr>
                    <tr>
                    <td>MA624L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA624L.pdf' target='_blank;'>Spatio-Temporal Modelling</a></td>
                    <td>12</td>
                    <td>MA6032</td>
                    </tr>
                    <tr>
                    <td>MA625L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA625L.pdf' target='_blank;'>Statistical Finance</a></td>
                    <td>12</td>
                    <td>MA6030</td>
                    </tr>
                    <tr>
                    <td>MA626L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA626L.pdf' target='_blank;'>Statistical Simulations and Data Analysis</a></td>
                    <td>12</td>
                    <td>MA6035</td>
                    </tr>
                    <tr>
                    <td>MA627L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA627L.pdf' target='_blank;'>Distributions and Sobolev Spaces</a></td>
                    <td>15</td>
                    <td>MA6027</td>
                    </tr>
                    <tr>
                    <td>MA628L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA628L.pdf' target='_blank;'>Statistical Analysis of Network</a></td>
                    <td>16</td>
                    <td>MA6039</td>
                    </tr>
                    <tr>
                    <td>MA629L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA629L.pdf' target='_blank;'>Statistical Learning: Theory and Applications</a></td>
                    <td>16</td>
                    <td>MA6040</td>
                    </tr>
                    <tr>
                    <td>MA630L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA630L.pdf' target='_blank;'>Differential Geometry </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>MA631L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA631L.pdf' target='_blank;'>Ergodic Theory </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>MA632L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA632L.pdf' target='_blank;'>Design of Experiments </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>MA633L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA633L.pdf' target='_blank;'>Numerical Analysis </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>MA634L</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA634L.pdf' target='_blank;'>Time Series Analysis  </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>
                    <tr>
                    <td>MA635P</td>
                    <td><a href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA635P.pdf' target='_blank;'>Scientific Computing Laboratory </a></td>
                    <td>27</td>
                    <td> </td>
                    </tr>


                    <tr>
                    <td>MA701L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA701L.pdf' target='_blank;'>Advanced Analysis</a></td>
                    <td>5</td>
                    <td>MA7021</td>
                    </tr>
                    <tr>
                    <td>MA702L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA702L.pdf' target='_blank;'>Advanced Algebra</a></td>
                    <td>7</td>
                    <td>MA7105</td>
                    </tr>
                    <tr>
                    <td>MA703L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA703L.pdf' target='_blank;'>Advanced Probability Theory</a></td>
                    <td>7</td>
                    <td>MA7107</td>
                    </tr>
                    <tr>
                    <td>MA704L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA704L.pdf' target='_blank;'>Advanced Statistical Inference</a></td>
                    <td>7</td>
                    <td>MA7103</td>
                    </tr>
                    <tr>
                    <td>MA705L</td>
                    <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/MAS/MA705L.pdf' target='_blank;'>Advanced Differential Equations</a></td>
                    <td>10</td>
                    <td>MA7101</td>
                    </tr>
                    </tbody>
                    </table>`
        }

        ,

        {
            id: 'headingElven',
            question: 'Mechanical Engineering',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                    <tr>
                        <th>Course Code <br>(Since July, 2022)</th>
                        <th>Course Title</th>
                        <th>Approved In <br>Senate</th>
                        <th>Course Code<br> (Prior to July, 2022)</th>
                        </tr>
                        <tr>
                        <td>ME201L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME201L.pdf' target='_blank;'>Thermodynamics</a></td>
                        <td>8</td>
                        <td>ME2101</td>
                        </tr>
                        <tr>
                        <td>ME202M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME202M.pdf' target='_blank;'>Strength of Materials</a></td>
                        <td>8</td>
                        <td>ME2103</td>
                        </tr>
                        <tr>
                        <td>ME203M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME203M.pdf' target='_blank;'>Material Science and Engineering</a></td>
                        <td>8</td>
                        <td>ME2105</td>
                        </tr>
                        <tr>
                        <td>ME204M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME204M.pdf' target='_blank;'>Fluid Mechanics and Hydraulic Machines</a></td>
                        <td>8</td>
                        <td>ME2202</td>
                        </tr>
                        <tr>
                        <td>ME205M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME205M.pdf' target='_blank;'>Kinematics and Dynamics and Machinery</a></td>
                        <td>8</td>
                        <td>ME2206</td>
                        </tr>
                        <tr>
                        <td>ME206M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME206M.pdf' target='_blank;'>Manufacturing Technology</a></td>
                        <td>8</td>
                        <td>ME2204</td>
                        </tr>
                        <tr>
                        <td>ME207L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME207L.pdf' target='_blank;'>Mechanics of Solids </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME208P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME208P.pdf' target='_blank;'>Applied Mechanics Laboratory </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME209L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME209L.pdf' target='_blank;'>Engineering Thermodynamics </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME210L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME210L.pdf' target='_blank;'>Theory of Mechanisms and Machines </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME211L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME211L.pdf' target='_blank;'>Fluid Mechanics </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME212L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME212L.pdf' target='_blank;'>Heat Transfer </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME213L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME213L.pdf' target='_blank;'>Mechanical Measurements and Metrology </a></td>
                        <td>27</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME214L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME214L.pdf' target='_blank;'>Foundry and Welding Processes </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME215L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME215L.pdf' target='_blank;'>Introduction to Materials Science </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME216L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME216L.pdf' target='_blank;'>Forming and Machining Processes </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME217M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME217M.pdf' target='_blank;'>Mechatronic System Design </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>ME301M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME301M.pdf' target='_blank;'>Machining Processes</a></td>
                        <td>8</td>
                        <td>ME3103</td>
                        </tr>
                        <tr>
                        <td>ME302L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME302L.pdf' target='_blank;'>Design of Machine Elements</a></td>
                        <td>8</td>
                        <td>ME3105</td>
                        </tr>
                        <tr>
                        <td>ME303M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME303M.pdf' target='_blank;'>Heat and Mass Transfer</a></td>
                        <td>8</td>
                        <td>ME3101</td>
                        </tr>
                        <tr>
                        <td>ME304M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME304M.pdf' target='_blank;'>Mechanical Measurements and Metrology</a></td>
                        <td>8</td>
                        <td>ME3107</td>
                        </tr>
                        <tr>
                        <td>ME305L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME305L.pdf' target='_blank;'>Applied Thermal Engineering</a></td>
                        <td>8</td>
                        <td>ME3202</td>
                        </tr>
                        <tr>
                        <td>ME306P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME306P.pdf' target='_blank;'>Machine Drawing</a></td>
                        <td>8</td>
                        <td>ME3292</td>
                        </tr>
                        <tr>
                        <td>ME307M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME307M.pdf' target='_blank;'>Vibrations and Control</a></td>
                        <td>8</td>
                        <td>ME3204</td>
                        </tr>
                        <tr>
                        <td>ME308M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME308M.pdf' target='_blank;'>System Dynamics and Control</a></td>
                        <td>23</td>
                        <td>NA</td>
                        </tr>
                        <tr>
                        <td>ME310L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME310L.pdf' target='_blank;'>Applied Thermal Engineering </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME311P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME311P.pdf' target='_blank;'>Machine Drawing </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME312M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME312M.pdf' target='_blank;'>Linear System Dynamics and Control </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME313L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME313L.pdf' target='_blank;'>Design of Machine Elements </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME314P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME314P.pdf' target='_blank;'>Materials and Measurements Laboratory </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME315L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME315L.pdf' target='_blank;'>Energy Conversion Systems </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME316L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME316L.pdf' target='_blank;'>CAD-CAM </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME317L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME317L.pdf' target='_blank;'>Introduction to Linear Elasticity </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME318P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME318P.pdf' target='_blank;'>Thermal and Manufacturing Laboratory </a></td>
                        <td>28</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>ME401M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME401M.pdf' target='_blank;'>Energy Conversion Systems</a></td>
                        <td>8</td>
                        <td>ME4101</td>
                        </tr>
                        <tr>
                        <td>ME402L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME402L.pdf' target='_blank;'>Operations Research</a></td>
                        <td>8</td>
                        <td>ME4103</td>
                        </tr>
                        <tr>
                        <td>ME403M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME403M.pdf' target='_blank;'>Mechatronics</a></td>
                        <td>8</td>
                        <td>ME4202</td>
                        </tr>
                        <tr>
                        <td>ME404L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME404L.pdf' target='_blank;'>Industrial Automation</a></td>
                        <td>8</td>
                        <td>ME4204</td>
                        </tr>
                        <tr>
                        <td>ME501M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME501M.pdf' target='_blank;'>Computational Fluid Dynamics</a></td>
                        <td>20</td>
                        <td>ME5101</td>
                        </tr>
                        <tr>
                        <td>ME502L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME502L.pdf' target='_blank;'>Finite Element Method in Engineering Mechanics</a></td>
                        <td>2</td>
                        <td>ME5102</td>
                        </tr>
                        <tr>
                        <td>ME503L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME503L.pdf' target='_blank;'>Joining Technologies</a></td>
                        <td>2</td>
                        <td>ME5103</td>
                        </tr>
                        <tr>
                        <td>ME504L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME504L.pdf' target='_blank;'>Additive Manufacturing</a></td>
                        <td>3</td>
                        <td>ME5111</td>
                        </tr>
                        <tr>
                        <td>ME505M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME505M.pdf' target='_blank;'>Experimental Methods for Engineers</a></td>
                        <td>21</td>
                        <td>ME5022</td>
                        </tr>
                        <tr>
                        <td>ME506L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME506L.pdf' target='_blank;'>Applied Numerical Methods</a></td>
                        <td>5</td>
                        <td>ME5029</td>
                        </tr>
                        <tr>
                        <td>ME507L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME507L.pdf' target='_blank;'>Composite Materials</a></td>
                        <td>5</td>
                        <td>ME5023</td>
                        </tr>
                        <tr>
                        <td>ME508L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME508L.pdf' target='_blank;'>Welding Metallurgy</a></td>
                        <td>5</td>
                        <td>ME5030</td>
                        </tr>
                        <tr>
                        <td>ME509L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME509L.pdf' target='_blank;'>Advanced Manufacturing Processes</a></td>
                        <td>6</td>
                        <td>ME5204</td>
                        </tr>
                        <tr>
                        <td>ME510L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME510L.pdf' target='_blank;'>Design for Manufacturing and Assembly</a></td>
                        <td>6</td>
                        <td>ME5206</td>
                        </tr>
                        <tr>
                        <td>ME511M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME511M.pdf' target='_blank;'>Material Characterization Techniques</a></td>
                        <td>6</td>
                        <td>ME5208</td>
                        </tr>
                        <tr>
                        <td>ME512L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME512L.pdf' target='_blank;'>Product Design and Development</a></td>
                        <td>6</td>
                        <td>ME5202</td>
                        </tr>
                        <tr>
                        <td>ME513L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME513L.pdf' target='_blank;'>Compressible Flow</a></td>
                        <td>8</td>
                        <td>ME5025</td>
                        </tr>
                        <tr>
                        <td>ME514L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME514L.pdf' target='_blank;'>Abrasive Machining and Finishing Processes</a></td>
                        <td>9</td>
                        <td>ME5031</td>
                        </tr>
                        <tr>
                        <td>ME515L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME515L.pdf' target='_blank;'>Advanced Fluid Mechanics</a></td>
                        <td>9</td>
                        <td>ME5104</td>
                        </tr>
                        <tr>
                        <td>ME516L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME516L.pdf' target='_blank;'>Convective Heat Transfer</a></td>
                        <td>9</td>
                        <td>ME5210</td>
                        </tr>
                        <tr>
                        <td>ME517L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME517L.pdf' target='_blank;'>Fracture and Fatigue</a></td>
                        <td>11</td>
                        <td>ME5032</td>
                        </tr>
                        <tr>
                        <td>ME518P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME518P.pdf' target='_blank;'>Design and Manufacturing Laboratory-I</a></td>
                        <td>12</td>
                        <td>ME5191</td>
                        </tr>
                        <tr>
                        <td>ME519L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME519L.pdf' target='_blank;'>Introduction to Continuum Mechanics</a></td>
                        <td>12</td>
                        <td>ME5027</td>
                        </tr>
                        <tr>
                        <td>ME520L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME520L.pdf' target='_blank;'>Mechanics and Control of Robotic Manipulators</a></td>
                        <td>12</td>
                        <td>ME5221</td>
                        </tr>
                        <tr>
                        <td>ME521M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME521M.pdf' target='_blank;'>Tribology and Surface Engineering</a></td>
                        <td>12</td>
                        <td>ME5033</td>
                        </tr>
                        <tr>
                        <td>ME522L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME522L.pdf' target='_blank;'>Wheeled Mobile Robots</a></td>
                        <td>12</td>
                        <td>ME5222</td>
                        </tr>
                        <tr>
                        <td>ME523L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME523L.pdf' target='_blank;'>Robotic Control Systems</a></td>
                        <td>14</td>
                        <td>ME5223</td>
                        </tr>
                        <tr>
                        <td>ME524L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME524L.pdf' target='_blank;'>Advanced Solidification Processes</a></td>
                        <td>16</td>
                        <td>ME5034</td>
                        </tr>
                        <tr>
                        <td>ME525L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME525L.pdf' target='_blank;'>Vibrations of Discrete Systems</a></td>
                        <td>16</td>
                        <td>ME5105</td>
                        </tr>
                        <tr>
                        <td>ME526P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME526P.pdf' target='_blank;'>Design and Manufacturing Laboratory-II</a></td>
                        <td>19</td>
                        <td>ME5292</td>
                        </tr>
                        <tr>
                        <td>ME527L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME527L.pdf' target='_blank;'>Design and Analysis of Welded Structures</a></td>
                        <td>19</td>
                        <td>ME5035</td>
                        </tr>
                        <tr>
                        <td>ME529L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME529L.pdf' target='_blank;'>Attitude Estimation and Control</a></td>
                        <td>21</td>
                        <td>ME5036</td>
                        </tr>
                        <tr>
                        <td>ME530L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME530L-Advanced Heat and Mass Transfer.pdf' target='_blank;'>Advanced Heat and Mass Transfer</a></td>
                        <td>21</td>
                        <td style="font-weight: 400;">ME5037</td>
                        </tr>
                        <tr>
                        <td>ME531L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME531L.pdf' target='_blank;'>Flow Instability and Turbulence</a></td>
                        <td>21</td>
                        <td>ME5038</td>
                        </tr>
                        <tr>
                        <td>ME532L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME532L-Hydrogen Production Storage and Safety.pdf' target='_blank;'>Hydrogen Production, Storage, and Safety</a></td>
                        <td>21</td>
                        <td>ME5039</td>
                        </tr>
                        <tr>
                        <td>ME533L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME533L-Refrigeration and Air-Conditioning.pdf' target='_blank;'>Refrigeration and Air-Conditioning</a></td>
                        <td>21</td>
                        <td>ME5040</td>
                        </tr>
                        <tr>
                        <td>ME534L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME534L-Sorption Cooling and Heating Systems.pdf' target='_blank;'>Sorption Cooling and Heating Systems</a></td>
                        <td>21</td>
                        <td>ME5041</td>
                        </tr>
                        <tr>
                        <td>ME535P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME535P-Fluids and Thermal Laboratory.pdf' target='_blank;'>Fluids and Thermal Laboratory</a></td>
                        <td>21</td>
                        <td style="font-weight: 400;">ME5192</td>
                        </tr>
                        <tr>
                        <td>ME536M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME536M.pdf' target='_blank;'>Model Analysis: Theory and Practice </a></td>
                        <td>27</td>
                        <td style="font-weight: 400;"> </td>
                        </tr>
                        <tr>
                        <td>ME537L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME537L.pdf' target='_blank;'>Fundamentals of Combustion </a></td>
                        <td>27</td>
                        <td style="font-weight: 400;"> </td>
                        </tr>
                        <tr>
                        <td>ME538L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME538L.pdf' target='_blank;'>Introduction to Field and Service Robots </a></td>
                        <td>27</td>
                        <td style="font-weight: 400;"> </td>
                        </tr>
                        <tr>
                        <td>ME539L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME539L.pdf' target='_blank;'>Advanced Mechanics of Solids</a></td>
                        <td>4</td>
                        <td style="font-weight: 400;">ME5107</td>
                        </tr>
                        <tr>
                        <td>ME540L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME540L.pdf' target='_blank;'>Design of Fluid-Thermal Equipment </a></td>
                        <td>27</td>
                        <td style="font-weight: 400;"> </td>
                        </tr>
                        <tr>
                        <td>ME541L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME541L.pdf' target='_blank;'>Special Topics in Elements of Smart Manufacturing </a></td>
                        <td>27</td>
                        <td style="font-weight: 400;"> </td>
                        </tr>
                        <tr>
                        <td>ME542L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME542L.pdf' target='_blank;'>Machine Learning for Mechanical Engineers </a></td>
                        <td>27</td>
                        <td style="font-weight: 400;"> </td>
                        </tr>
                        <tr>
                        <td>ME543L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME543L.pdf' target='_blank;'>Continuum Mechanics </a></td>
                        <td>27</td>
                        <td style="font-weight: 400;"> </td>
                        </tr>
                        <tr>
                        <td>ME601L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME601L.pdf' target='_blank;'>Advanced Thermodynamics</a></td>
                        <td>20</td>
                        <td>ME6021</td>
                        </tr>
                        <tr>
                        <td>ME602L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME602L.pdf' target='_blank;'>Theory of Plasticity</a></td>
                        <td>10</td>
                        <td>ME6221</td>
                        </tr>
                        <tr>
                        <td>ME603L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME603L.pdf' target='_blank;'>Vibrations of Continuous Systems</a></td>
                        <td>10</td>
                        <td>ME6022</td>
                        </tr>
                        <tr>
                        <td>ME604L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME604L.pdf' target='_blank;'>Martensitic Phase Transformations</a></td>
                        <td>11</td>
                        <td>ME6023</td>
                        </tr>
                        <tr>
                        <td>ME605L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME605L.pdf' target='_blank;'>Wave Propagation in Solids</a></td>
                        <td>11</td>
                        <td>ME6024</td>
                        </tr>
                        <tr>
                        <td>ME606L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME606L.pdf' target='_blank;'>Pollutant Formation and Control in Combustion</a></td>
                        <td>17</td>
                        <td>ME6025</td>
                        </tr>
                        <tr>
                        <td>ME607L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME607L.pdf' target='_blank;'>Machine Learning in Mechanics</a></td>
                        <td>19</td>
                        <td>ME6026</td>
                        </tr>
                        <tr>
                        <td>ME608L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME608L.pdf' target='_blank;'>Structural Transformations in Crystalline Solids</a></td>
                        <td>22</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>ME611L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME611L.pdf' target='_blank;'>Wind Turbine Systems</a></td>
                        <td>20</td>
                        <td>ME6027</td>
                        </tr>
                        <tr>
                        <td>ME701L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME701L.pdf' target='_blank;'>Nonlinear Dynamical Systems</a></td>
                        <td>10</td>
                        <td>ME7021</td>
                        </tr>
                        <tr>
                        <td>ME702L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/ME/ME702L.pdf' target='_blank;'>Nonlinear Finite Element Methods</a></td>
                        <td>10</td>
                        <td>ME7221</td>
                        </tr>
                    </tbody>
                    </table>`
        }

        ,

        {
            id: 'headingTwel',
            question: 'Physics',
            answer: `<table className='table table-bordered mb-40'>   
                     <tbody style="line-height: 2.5;">
                        <tr>
                        <th>Course Code <br>(Since July, 2022)</th>
                        <th>Course Title</th>
                        <th>Approved In <br>Senate</th>
                        <th>Course Code<br> (Prior to July, 2022)</th>
                        </tr>
                        <tr>
                        <td>PH101L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH101L.pdf' target='_blank;'>Introduction to Classical Mechanics</a></td>
                        <td>4</td>
                        <td>PH1101</td>
                        </tr>
                        <tr>
                        <td>PH102L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH102L.pdf' target='_blank;'>Introduction to Electrodynamics and Quantum Mechanics</a></td>
                        <td>4</td>
                        <td>PH1202</td>
                        </tr>
                        <tr>
                        <td>PH103P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH103P.pdf' target='_blank;'>Physics Laboratory</a></td>
                        <td>4</td>
                        <td>PH1103</td>
                        </tr>
                        <tr>
                        <td>PH104L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH104L.pdf' target='_blank;'>Introduction to Classical Physics</a></td>
                        <td>26</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>PH105L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH105L.pdf' target='_blank;'>Introduction to Quantum Science and Technology </a></td>
                        <td>27</td>
                        <td> - </td>
                        </tr>
                        <tr>
                        <td>PH201L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH201L.pdf' target='_blank;'>Kinetic Theory of Gases and Thermodynamics </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>PH202L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH202L.pdf' target='_blank;'>Applied Optics </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>PH203P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH203P.pdf' target='_blank;'>Mechanics, Electricity and Magnetism Laboratory </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>PH301P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH301P.pdf' target='_blank;'>Applied Optics and Material Physics Laboratory </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>PH302P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH302P.pdf' target='_blank;'>Advanced Engineering Physics Laboratory </a></td>
                        <td>28</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>PH501M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH501M.pdf' target='_blank;'>Applied Electronics</a></td>
                        <td>10</td>
                        <td>PH5109</td>
                        </tr>
                        <tr>
                        <td>PH502L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH502L.pdf' target='_blank;'>Classical Electrodynamics</a></td>
                        <td>10</td>
                        <td>PH5105</td>
                        </tr>
                        <tr>
                        <td>PH503L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH503L.pdf' target='_blank;'>Classical Mechanics</a></td>
                        <td>10</td>
                        <td>PH5103</td>
                        </tr>
                        <tr>
                        <td>PH504M</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH504M.pdf' target='_blank;'>Computational Physics</a></td>
                        <td>10</td>
                        <td>PH5210</td>
                        </tr>
                        <tr>
                        <td>PH505L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH505L.pdf' target='_blank;'>Condensed Matter Physics</a></td>
                        <td>10</td>
                        <td>PH5208</td>
                        </tr>
                        <tr>
                        <td>PH506L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH506L.pdf' target='_blank;'>Mathematical Physics I</a></td>
                        <td>10</td>
                        <td>PH5101</td>
                        </tr>
                        <tr>
                        <td>PH507L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH507L.pdf' target='_blank;'>Mathematical Physics II</a></td>
                        <td>10</td>
                        <td>PH5202</td>
                        </tr>
                        <tr>
                        <td>PH508P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH508P.pdf' target='_blank;'>Physics Laboratory I</a></td>
                        <td>10</td>
                        <td>PH5191</td>
                        </tr>
                        <tr>
                        <td>PH509P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH509P.pdf' target='_blank;'>Physics Laboratory II</a></td>
                        <td>10</td>
                        <td>PH5292</td>
                        </tr>
                        <tr>
                        <td>PH510L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH510L.pdf' target='_blank;'>Quantum Mechanics I</a></td>
                        <td>10</td>
                        <td>PH5107</td>
                        </tr>
                        <tr>
                        <td>PH511L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH511L.pdf' target='_blank;'>Quantum Mechanics II</a></td>
                        <td>10</td>
                        <td>PH5204</td>
                        </tr>
                        <tr>
                        <td>PH512L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH512L.pdf' target='_blank;'>Statistical Physics</a></td>
                        <td>10</td>
                        <td>PH5206</td>
                        </tr>
                        <tr>
                        <td>PH513L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH513L.pdf' target='_blank;'>Introduction to Quantum Entanglement and Quantum Computing</a></td>
                        <td>17</td>
                        <td>PH5021</td>
                        </tr>
                        <tr>
                        <td>PH514L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH514L.pdf' target='_blank;'>Introduction to Quantum Technology</a></td>
                        <td>24</td>
                        <td>  </td>
                        </tr>
                        <tr>
                        <td>PH515L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH515L.pdf' target='_blank;'>Basics of Quantum Computing</a></td>
                        <td>24</td>
                        <td> </td>
                        </tr>
                        <tr>
                        <td>PH601L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH601L.pdf' target='_blank;'>Atomic and Molecular Physics</a></td>
                        <td>10</td>
                        <td>PH6101</td>
                        </tr>
                        <tr>
                        <td>PH602L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH602L.pdf' target='_blank;'>Classical and Quantum Optics</a></td>
                        <td>10</td>
                        <td>PH6103</td>
                        </tr>
                        <tr>
                        <td>PH603P</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH603P.pdf' target='_blank;'>Advanced Physics Laboratory</a></td>
                        <td>10</td>
                        <td>PH6191</td>
                        </tr>
                        <tr>
                        <td>PH604L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH604L.pdf' target='_blank;'>Nuclear and Particle Physics</a></td>
                        <td>10</td>
                        <td>PH6202</td>
                        </tr>
                        <tr>
                        <td>PH605L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH605L.pdf' target='_blank;'>Basics and Applications of Plasma Physics</a></td>
                        <td>8</td>
                        <td>PH6021</td>
                        </tr>
                        <tr>
                        <td>PH606L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH606L.pdf' target='_blank;'>Fundamentals of Laser Physics</a></td>
                        <td>8</td>
                        <td>PH6022</td>
                        </tr>
                        <tr>
                        <td>PH607L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH607L.pdf' target='_blank;'>Magnetism and Superconductivity</a></td>
                        <td>9</td>
                        <td>PH6023</td>
                        </tr>
                        <tr>
                        <td>PH608L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH608L.pdf' target='_blank;'>Introduction to Condensed Matter Theory</a></td>
                        <td>10</td>
                        <td>PH6121</td>
                        </tr>
                        <tr>
                        <td>PH612L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH612L.pdf' target='_blank;'>Theory of Atomic Collisions and Spectroscopy</a></td>
                        <td>20</td>
                        <td>PH6203</td>
                        </tr>
                        <tr>
                        <td>PH613L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH613L.pdf' target='_blank;'>Advanced Quantum Computing</a></td>
                        <td>24</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>PH614L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH614L.pdf' target='_blank;'>Many-body theories of electron correlation</a></td>
                        <td>24</td>
                        <td></td>
                        </tr>
                        <tr>
                        <td>PH701L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH701L.pdf' target='_blank;'>Physical Techniques in Materials Science</a></td>
                        <td>6</td>
                        <td>PH7021</td>
                        </tr>
                        <tr>
                        <td>PH702L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH702L.pdf' target='_blank;'>Foundation of Experimental Physics</a></td>
                        <td>9</td>
                        <td>PH7101</td>
                        </tr>
                        <tr>
                        <td>PH703L</td>
                        <td><a className='c-link' href='https://files.iittp.ac.in/pdfs/syllabus/2022_NewCourses/PH/PH703L.pdf' target='_blank;'>Foundations of Theoretical Physics</a></td>
                        <td>9</td>
                        <td>PH7103</td>
                        </tr>
                    </tbody>
                    </table>`
        }



    ];
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Academic" />
            <section className="project-detail">

                <Container>
                    <Row>

                        <div className="c-heading mb-5">
                            <h1>Syllabus</h1>
                        </div>



                        <div className="col-lg-4 col-md-4  c-left custom-padding-color wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                            <Academicleft activeIndex={13} />
                        </div>


                        <div className="col-lg-8 col-md-8 c-right text-center wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s" >
                            <div className="faq-wrap pl-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="accordion" id="accordionExample">
                                    {faqData.map((item, index) => (
                                        <div className="card" key={index}>
                                            <div className="card-header" id={item.id}>
                                                <h2 className="mb-0">
                                                    <button className={`faq-btn${activeIndex === index ? '' : ' collapsed'}`}
                                                        type="button" data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse${index}`}
                                                        onClick={() => handleToggle(index)} >
                                                        {item.question}
                                                    </button>
                                                </h2>
                                            </div>
                                            <div id={`collapse${index}`}
                                                className={`collapse${activeIndex === index ? ' show' : ''} lower-content`}
                                                data-bs-parent="#accordionExample">
                                                <div dangerouslySetInnerHTML={{ __html: item.answer }} className="card-body"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    </Row>
                </Container>


            </section>
        </>
    );
}

export default Main;